<template>
  <div id="footer-bar">
    <div id="demo" v-if="overlayVideo">
      <balloon position="bottom-left" v-on:close="closeVideo">
        <div class="row d-flex align-items-center mx-0">
          <div class="col-md-7">
            <!-- <video
              autoplay
              loop
              muted
              class="baloon-video"
              :src="overlayVideo"
              type="video/mp4"
            >
              <br />
              <div class="mt-4">
                {{ description }}
                ,<br />
              </div>
            </video> -->
            <iframe
              class="baloon-video"
              :src="
                `https://www.youtube.com/embed/` +
                  overlayVideo +
                  `?autoplay=1&amp;mute=1&amp;modestbranding=1`
              "
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            >
            </iframe>
          </div>
          <div class="col-md-5 mt-4" v-if="description">
            <p class="video-description">{{ description }}</p>
            <br />
          </div>
        </div>
      </balloon>
    </div>
    <footer class="page-footer">
      <div class="footer footer-wrapper">
        <back-to-top bottom="50px" right="50px" visibleoffset="600">
          <button type="button" class="btn btn-info btn-to-top">
            <i class="fa fa-chevron-up"></i>
          </button>
        </back-to-top>
        <b-overlay :show="modal" rounded="sm">
          <div class="footer-middle">
            <div class="container">
              <div class="row">
                <div class="cat-footer">
                  <ul>
                    <li class="category-hover">
                      <a
                        @click="ViewCategoryProduct(' Animals & Pet Supplies ')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512.001 512.001"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M463.244,195.7L410.746,43.153V7.868c0-2.461-1.152-4.78-3.112-6.268s-4.502-1.973-6.874-1.309l-34.525,9.656    l-34.64-9.657c-1.381-0.385-2.844-0.385-4.225,0l-34.644,9.658L258.083,0.29c-1.381-0.385-2.844-0.385-4.225,0l-34.643,9.658    L184.572,0.29c-1.381-0.385-2.844-0.385-4.225,0l-34.645,9.658L112.05,0.567c-0.907-0.365-1.898-0.566-2.935-0.566h-0.171    c-3.933,0-7.262,2.905-7.795,6.8c-0.127,0.923-0.086,1.834,0.098,2.701v33.664L48.756,195.7c-0.283,0.823-0.428,1.689-0.428,2.56    v156.913c0,4.346,3.522,7.867,7.867,7.867c4.345,0,7.867-3.521,7.867-7.867V199.576l50.67-147.24h222.328    c4.345,0,7.867-3.521,7.867-7.867c0-4.346-3.522-7.867-7.867-7.867H116.983V18.276l26.606,7.417c1.381,0.385,2.844,0.385,4.225,0    l34.643-9.658l34.643,9.658c1.381,0.385,2.844,0.385,4.225,0l34.643-9.658l34.643,9.658c1.381,0.385,2.844,0.385,4.225,0    l34.644-9.658l34.643,9.658c1.385,0.385,2.848,0.385,4.232-0.002l26.654-7.454v18.364h-32.164c-4.345,0-7.867,3.521-7.867,7.867    c0,4.346,3.522,7.867,7.867,7.867h29.004L342.512,195.7c-0.283,0.823-0.428,1.689-0.428,2.56v298.007H64.062V380.959    c0-4.346-3.522-7.867-7.867-7.867c-4.345,0-7.867,3.521-7.867,7.867v123.175c0,4.346,3.522,7.867,7.867,7.867h293.76    c0.256,0,0.513-0.014,0.769-0.039c0.124-0.012,0.244-0.035,0.366-0.052c0.128-0.019,0.257-0.034,0.385-0.059    c0.15-0.029,0.297-0.069,0.444-0.107c0.098-0.025,0.195-0.046,0.292-0.076c0.156-0.046,0.308-0.103,0.46-0.159    c0.071-0.026,0.144-0.046,0.214-0.074l0.121-0.048c0.005-0.002,0.011-0.004,0.018-0.007l105.713-42.42    c2.983-1.198,4.937-4.089,4.937-7.302V198.259C463.672,197.389,463.527,196.523,463.244,195.7z M447.937,456.337l-90.116,36.162    V199.576l45.057-130.931l45.058,130.93V456.337z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M215.963,341.457l-0.327-0.328c-6.747-6.747-17.155-10.312-30.099-10.312c-22.006-0.002-47.077,10.227-55.884,22.801    c-3.787,5.406-4.779,11.394-2.792,16.859c3.214,8.841,9.542,16.123,18.809,21.644c3.916,2.333,7.543,5.167,10.815,8.459    c3.257,3.237,6.091,6.864,8.425,10.781c5.522,9.268,12.804,15.595,21.643,18.809c1.84,0.669,3.755,1.008,5.693,1.008    c0.001,0,0.001,0,0.002,0c10.298,0,20.157-9.541,27.049-26.177C227.792,384.496,230.353,355.845,215.963,341.457z     M204.761,398.978c-5.104,12.32-10.73,16.466-12.512,16.465c-0.074,0-0.171-0.007-0.32-0.062    c-5.343-1.943-9.885-6.005-13.503-12.075c-3.008-5.049-6.658-9.722-10.816-13.854c-4.168-4.193-8.84-7.843-13.887-10.85    c-6.069-3.616-10.132-8.159-12.075-13.502c-0.246-0.678,0.453-1.829,0.892-2.456c5.214-7.443,25.132-16.096,42.997-16.096    c8.556,0,15.295,2.027,19.016,5.747l0.224,0.225C213.289,361.032,211.453,382.826,204.761,398.978z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M233.236,253.938c-3.728-1.414-7.626-2.129-11.586-2.129c-13.502,0-25.79,8.484-30.577,21.111    c-5.981,15.774-5.512,50.455,13.155,57.533c2.108,0.8,4.371,1.204,6.724,1.204c0.001,0,0,0,0.001,0    c17.977,0,36.69-23.488,41.264-35.556C258.61,279.245,250.095,260.331,233.236,253.938z M237.507,290.523    c-3.802,10.03-18.706,25.401-26.552,25.4c-0.447,0-0.822-0.06-1.147-0.183c-6.078-2.305-8.557-25.276-4.022-37.241    c2.485-6.553,8.861-10.955,15.866-10.955c2.048,0,4.068,0.372,6.007,1.108C236.404,271.967,240.821,281.779,237.507,290.523z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M180.622,284.414c-2.734-13.54-14.732-23.367-28.529-23.367c-1.934,0-3.882,0.196-5.79,0.581    c-7.627,1.54-14.198,5.958-18.501,12.44c-4.304,6.483-5.826,14.252-4.285,21.879c2.629,13.011,17.443,36.911,33.763,36.913    c0.001,0,0.001,0,0.002,0c1.127,0,2.25-0.112,3.341-0.331C178.055,329.008,183.559,298.954,180.622,284.414z M157.509,317.106    c-0.068,0.014-0.142,0.021-0.226,0.021h-0.001c-5.273-0.001-16.416-14.759-18.342-24.295c-0.708-3.507-0.008-7.079,1.97-10.061    c1.979-2.98,5-5.012,8.507-5.72c0.884-0.179,1.784-0.27,2.675-0.27c6.337,0,11.848,4.52,13.107,10.747    C167.333,298.091,161.915,316.216,157.509,317.106z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M303.091,323.792c-4.787-12.626-17.076-21.11-30.577-21.11c-3.96,0-7.858,0.716-11.586,2.129    c-7.828,2.968-17.489,10.059-24.611,18.064c-9.534,10.716-12.992,21.344-9.739,29.926c5.635,14.865,27.143,16.469,36.128,16.469    c8.047,0,15.848-1.207,21.404-3.314C300.968,359.565,309.482,340.65,303.091,323.792z M278.532,351.245    c-3.73,1.414-9.793,2.291-15.826,2.291c-11.907,0-20.239-3.209-21.416-6.313c-0.802-2.117,0.978-7.365,6.782-13.889    c6.292-7.071,13.966-12.116,18.433-13.81c1.94-0.734,3.961-1.108,6.008-1.108c7.005,0,13.381,4.401,15.866,10.954    C291.694,338.116,287.277,347.929,278.532,351.245z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M272.616,376.406c-2.42-0.489-5.202-0.736-8.27-0.736c-14.333,0-36.773,5.523-39.845,20.736    c-1.644,8.137,2.897,17.028,12.786,25.035c7.262,5.88,16.603,10.619,23.795,12.072c1.908,0.385,3.857,0.581,5.791,0.581    c13.796,0,25.795-9.827,28.53-23.366C298.583,394.982,288.361,379.587,272.616,376.406z M279.979,407.611    c-1.258,6.227-6.77,10.747-13.107,10.747c-0.891,0-1.791-0.09-2.676-0.27c-4.003-0.809-11.131-4.117-17.008-8.876    c-5.774-4.675-7.52-8.425-7.265-9.69c0.633-3.131,12.066-8.117,24.422-8.117c2.521,0,4.195,0.232,5.155,0.425    C276.741,393.292,281.441,400.372,279.979,407.611z"
                              />
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Animals &amp; Pet Supplies</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Apparel & Accessories')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Capa_1"
                          viewBox="0 0 437.899 437.899"
                          xml:space="preserve"
                        >
                          <path
                            d="M389.228,324.802h-1.666V30.553c6.419-1.937,11.11-7.899,11.11-14.942c0-8.608-7.003-15.611-15.61-15.611  c-8.607,0-15.61,7.003-15.61,15.611c0,7.042,4.691,13.005,11.11,14.942v6.012h-78.897c-4.614-0.214-17.725-1.985-24.48-7.657  c-13.66-11.469-32.107-13.982-55.529-14.071c-0.03,0-0.058-0.009-0.088-0.009c-0.208,0-0.409,0.004-0.617,0.004  c-0.207,0-0.408-0.004-0.616-0.004c-0.03,0-0.058,0.008-0.088,0.009c-23.423,0.089-41.868,2.602-55.531,14.071  c-7.861,6.601-23.25,7.588-24.494,7.657H59.336v-6.012c6.42-1.937,11.111-7.899,11.111-14.942C70.448,7.003,63.445,0,54.837,0  s-15.61,7.003-15.61,15.611c0,7.042,4.691,13.004,11.109,14.941v294.249h-1.664c-10.584,0-18.875,12.348-18.875,28.11v80.487  c0,2.485,2.015,4.5,4.5,4.5c2.485,0,4.5-2.015,4.5-4.5v-18.758h360.305v18.758c0,2.485,2.015,4.5,4.5,4.5c2.485,0,4.5-2.015,4.5-4.5  v-80.487C408.102,337.149,399.812,324.802,389.228,324.802z M389.228,333.802c4.67,0,9.874,7.848,9.874,19.11v34.959h-11.54v-54.069  H389.228z M59.336,387.871V104.023h78.396c-3.379,2.064-6.241,5.581-6.989,10.972l-43.798,23.746  c-2.093,0.975-15.563,8.002-16.045,27.418c-0.148,5.961,1.933,28.418,2.021,29.371c0.125,1.35,0.852,2.57,1.979,3.324  c1.126,0.754,2.533,0.96,3.826,0.561l11.267-3.47v69.399c0,1.486,0.734,2.877,1.961,3.715c0.539,0.368,13.529,9.012,43.005,9.012  c29.478,0,42.466-8.645,43.004-9.012c1.227-0.839,1.961-2.229,1.961-3.715v-69.4l11.269,3.47c1.292,0.397,2.699,0.193,3.827-0.561  c1.126-0.753,1.852-1.974,1.977-3.323c0.089-0.953,2.168-23.41,2.021-29.371c-0.482-19.416-13.951-26.443-16.044-27.418  l-43.137-23.383c1.025-4.094,4.583-4.686,6.222-4.724c2.485,0,4.5-2.015,4.5-4.5v-2.11h106.878  c-3.379,2.064-6.241,5.581-6.989,10.972l-43.938,23.82c-1.811,0.981-2.724,3.066-2.218,5.063c0.507,1.996,2.303,3.394,4.362,3.394  h9.116v153.464c0,2.485,2.015,4.5,4.5,4.5h34.145c-1.645,12.928-2.636,27.845-2.636,45.04c0,2.485,2.015,4.5,4.5,4.5h54.061h54.063  c2.485,0,4.5-2.015,4.5-4.5c0-80.095-21.462-110.89-30.652-120.404c20.581-22.359,17.341-54.431,17.185-55.855  c-0.251-2.282-2.179-4.009-4.474-4.009c-5.481,0-6.802-3.5-7.101-4.852v-17.884h12.488c2.059,0,3.855-1.398,4.362-3.394  c0.506-1.996-0.407-4.081-2.218-5.063l-43.273-23.458c1.025-4.094,4.583-4.686,6.221-4.724c2.485,0,4.5-2.015,4.5-4.5v-2.11h50.618  v283.848H59.336z M378.562,95.023h-50.651c-0.344-7.704-6.7-13.87-14.487-13.87c-7.786,0-14.143,6.166-14.486,13.87h-28.706  c-0.344-7.704-6.7-13.87-14.486-13.87c-7.786,0-14.143,6.166-14.486,13.87h-90.732c-0.344-7.704-6.7-13.87-14.486-13.87  c-7.786,0-14.143,6.166-14.486,13.87H59.336V75.766h319.226V95.023z M331.177,233.765c0.303,0.211,29.751,21.777,30.704,112.01  h-49.539h-49.537c0.953-90.233,30.4-111.799,30.664-111.984c1.152-0.767,1.889-2.021,1.994-3.401c0.106-1.38-0.429-2.733-1.45-3.667  c-16.879-15.427-18.161-39.226-17.994-48.168c8.07-1.801,11.226-8.552,11.76-12.371c0.028-0.207,0.043-1.401,0.043-1.401  c5.204,5.688,13.052,9.953,24.52,9.953c11.468,0,19.316-4.265,24.521-9.952c0,0,0.015,1.194,0.044,1.401  c0.534,3.821,3.692,10.574,11.769,12.372c0.186,8.933-1.059,32.682-18.002,48.167c-1.009,0.923-1.524,2.268-1.435,3.633  C329.33,231.72,330.055,232.983,331.177,233.765z M226.399,138.271l28.264-15.323l19.398,10.516l-8.867,4.807H226.399z   M226.772,147.271h52.05v17.866c-0.323,1.432-1.667,4.869-7.1,4.869c-2.296,0-4.223,1.728-4.474,4.009  c-0.155,1.425-3.395,33.496,17.186,55.855c-6.742,6.979-20.089,25.414-26.721,66.364h-30.941V147.271z M333.162,154.579  c-4.198,7.403-11.202,11.157-20.819,11.157c-9.616,0-16.621-3.753-20.818-11.157c-1.456-2.567-2.347-5.178-2.889-7.307h47.414  C335.507,149.402,334.617,152.012,333.162,154.579z M301.811,138.271l-8.866-4.807l19.397-10.516l28.266,15.323H301.811z   M308.128,114.996l-24.626,13.351l-23.959-12.989c1.025-4.094,4.583-4.686,6.221-4.724c2.485,0,4.5-2.015,4.5-4.5v-2.11h44.854  C311.739,106.087,308.876,109.604,308.128,114.996z M250.267,95.023c0.323-2.738,2.654-4.87,5.478-4.87  c2.823,0,5.154,2.132,5.478,4.87H250.267z M307.946,95.023c0.323-2.738,2.654-4.87,5.478-4.87c2.823,0,5.155,2.132,5.478,4.87  H307.946z M141.518,95.023h-10.955c0.323-2.738,2.654-4.87,5.478-4.87C138.864,90.153,141.195,92.285,141.518,95.023z   M179.173,146.898c0.429,0.191,10.485,4.85,10.848,19.484c0.088,3.523-0.812,14.939-1.49,22.795l-11.782-3.628  c-1.365-0.42-2.848-0.169-3.997,0.681c-1.15,0.849-1.827,2.192-1.827,3.62v72.823c-4.31,2.062-15.777,6.399-35.965,6.399  c-20.208,0-31.679-4.346-35.966-6.396V189.85c0-1.428-0.678-2.771-1.827-3.62c-1.149-0.849-2.635-1.101-3.997-0.681l-11.779,3.628  c-0.68-7.855-1.579-19.271-1.491-22.795c0.362-14.634,10.42-19.292,10.81-19.467c0.133-0.056,11.901-6.429,11.901-6.429  c0.604,4.023,2.154,8.922,5.833,13.229c5.645,6.607,14.566,9.958,26.517,9.958c11.95,0,20.872-3.35,26.518-9.958  c3.678-4.306,5.229-9.203,5.834-13.227C167.311,140.487,179.075,146.854,179.173,146.898z M155.096,147.271  c-0.153,0.199-2.775,7.4-20.137,7.4c-17.361,0-19.967-7.18-20.136-7.4H155.096z M158.66,135.798  c0.001,0.697-0.036,1.542-0.138,2.474H111.4c-0.102-0.934-0.139-1.779-0.138-2.477l23.694-12.846L158.66,135.798z M376.452,15.611  c0-3.646,2.966-6.611,6.61-6.611s6.61,2.966,6.61,6.611c0,3.645-2.966,6.609-6.61,6.609S376.452,19.256,376.452,15.611z   M361.579,45.565h16.983v21.2h-18.256c2.471-3.335,3.826-7.343,3.827-11.569C364.133,51.761,363.235,48.47,361.579,45.565z   M299.371,45.561c0.064,0.003,32.83,0.004,32.83,0.004c-0.816,1.803-1.261,3.769-1.261,5.807c0,3.769,1.467,7.311,4.132,9.976  c1.758,1.757,4.606,1.757,6.364-0.001c1.757-1.758,1.757-4.607-0.001-6.364c-0.964-0.963-1.495-2.245-1.495-3.608  c0.001-1.363,0.532-2.645,1.497-3.61c1.418-1.418,3.303-2.198,5.309-2.198c2.005,0,3.89,0.781,5.309,2.2  c1.985,1.984,3.079,4.623,3.079,7.429c0,2.807-1.094,5.446-3.08,7.431c-2.342,2.341-6.884,3.884-12.158,4.14h-11.507  c-9.622-0.37-29.469-2.773-39.583-15.786c-2.522-3.245-5.101-6.225-7.712-8.928C289.997,45.11,298.832,45.538,299.371,45.561z   M247.418,32.889c9.982,0,22.758,8.79,34.281,23.614c3.346,4.305,7.44,7.652,11.852,10.263h-36.908  c3.565-5.009,3.444-11.461-0.578-15.822c-1.685-1.827-4.532-1.941-6.359-0.256c-1.826,1.686-1.94,4.532-0.256,6.359  c1.573,1.705,0.391,4.09-0.787,5.277c-0.997,1.005-4.684,3.892-10.201-1.128c-7.23-6.576-8.632-14.257-3.846-21.073  c3.33-4.742,7.385-7.107,12.395-7.229C247.147,32.891,247.283,32.889,247.418,32.889z M218.95,23.832  c7.789,0.014,14.945,0.299,21.477,1.097c-5.145,1.585-9.628,4.97-13.175,10.021c-7.183,10.23-5.589,22.295,4.04,31.815h-24.684  c9.629-9.521,11.222-21.585,4.039-31.815c-3.547-5.051-8.031-8.436-13.175-10.021C204.004,24.131,211.161,23.846,218.95,23.832z   M190.886,32.893c5.011,0.122,9.065,2.486,12.395,7.229c4.786,6.816,3.385,14.497-3.844,21.073  c-5.522,5.021-9.206,2.132-10.203,1.127c-1.179-1.186-2.36-3.571-0.787-5.276c1.685-1.827,1.57-4.673-0.256-6.359  c-1.827-1.684-4.675-1.569-6.359,0.256c-4.021,4.36-4.143,10.813-0.578,15.822h-36.917c4.415-2.61,8.514-5.955,11.862-10.263  C167.88,41.476,180.853,32.668,190.886,32.893z M85.848,47.764c1.416-1.417,3.3-2.198,5.305-2.198c2.006,0,3.891,0.78,5.309,2.199  c0.965,0.964,1.496,2.246,1.496,3.609c0.001,1.363-0.53,2.645-1.494,3.608c-1.758,1.757-1.758,4.606-0.001,6.364  c1.757,1.757,4.605,1.758,6.364,0.001c2.665-2.665,4.132-6.207,4.131-9.976c0-2.038-0.443-4.004-1.26-5.807  c0,0,32.766-0.001,32.83-0.004c0.538-0.023,9.38-0.451,18.284-3.512c-2.614,2.705-5.196,5.686-7.718,8.93  c-10.112,13.01-29.958,15.415-39.582,15.786H98.004c-5.276-0.255-9.817-1.798-12.158-4.139c-1.985-1.985-3.079-4.625-3.079-7.431  C82.766,52.389,83.86,49.75,85.848,47.764z M76.321,45.565c-1.656,2.905-2.555,6.196-2.554,9.631c0,4.226,1.355,8.235,3.827,11.569  H59.336v-21.2H76.321z M48.227,15.611c0-3.646,2.966-6.611,6.61-6.611s6.61,2.966,6.61,6.611c0,3.645-2.966,6.609-6.61,6.609  S48.227,19.256,48.227,15.611z M48.672,333.802h1.664v54.069H38.797v-34.959C38.797,341.65,44.001,333.802,48.672,333.802z   M38.797,405.642v-8.771h360.305v8.771H38.797z"
                          />
                        </svg>
                        <span class="cat-name">Apparel & Accessories</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct(' Arts & Entertainment')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Capa_1"
                          viewBox="0 0 208.204 208.204"
                          xml:space="preserve"
                        >
                          <path
                            d="M83.536,208.204c-0.001,0-0.001,0-0.001,0c-4.229,0-8.409-0.68-12.425-2.021c-12.261-4.094-29.286-12.973-40.765-32.028  C9.018,138.758,0.998,86.08,0.92,85.552c-0.136-0.911,0.368-1.796,1.22-2.145c23.929-9.8,48.852-17.602,74.103-23.198  C84.545,29.028,98.881,1.354,99.026,1.074c0.426-0.816,1.358-1.234,2.248-1.018c36.468,8.91,71.785,22.332,104.967,39.892  c0.813,0.431,1.229,1.361,1.004,2.254c-0.129,0.518-13.267,52.157-37.955,85.297c-9.42,12.645-22.084,21.476-37.659,26.263  c-2.078,18.565-10.966,32.37-18.521,41.015C105.653,203.31,94.873,208.204,83.536,208.204z M5.125,86.51  c1.489,8.905,9.77,54.251,28.645,85.58c10.851,18.011,26.983,26.417,38.606,30.298c3.607,1.204,7.361,1.815,11.157,1.815  c0,0,0.002,0,0.002,0c10.184,0,19.865-4.395,26.563-12.059c8.063-9.227,17.728-24.639,17.979-45.664  c0.439-36.894-15.276-79.747-18.566-88.298c-1.94,0.285-3.879,0.585-5.815,0.895c-0.055,0.008-0.109,0.015-0.163,0.019  c-8.373,1.343-16.866,2.955-25.247,4.791c-0.116,0.025-0.232,0.04-0.348,0.045C53.142,69.378,28.656,76.971,5.125,86.51z   M130.558,122.328c1.176,8.683,1.727,16.804,1.639,24.197c-0.012,0.937-0.045,1.888-0.102,2.891  c13.995-4.638,25.42-12.805,33.988-24.306c21.861-29.345,34.532-73.652,36.884-82.366c-32.015-16.797-66.013-29.718-101.102-38.422  C98.965,10.132,87.81,33.27,80.645,59.257c6.833-1.443,13.754-2.739,20.639-3.865c0.02-1.677,0.335-3.348,0.932-4.918  c0.08-0.209,0.171-0.413,0.264-0.614l0.074-0.164c0.306-0.681,0.964-1.135,1.709-1.178l21.811-1.267  c0.76-0.042,1.452,0.332,1.834,0.972c2.261,3.791,2.662,8.323,1.1,12.433c-1.817,4.781-6.099,8.204-11.056,9.035  c2.305,6.981,5.05,16.047,7.521,26.2c4.684,1.907,8.723,5.486,12.631,11.175c1.138,1.656,2.166,3.433,3.058,5.28  c5.907,12.261,4.417,21.206,4.351,21.581c-0.144,0.811-0.771,1.451-1.578,1.612c-0.808,0.16-1.631-0.19-2.076-0.883  c-0.046-0.071-4.666-7.221-11.169-12.229C130.644,122.394,130.601,122.361,130.558,122.328z M129.744,116.839  c1.18,0.784,2.315,1.595,3.385,2.419c3.416,2.631,6.309,5.737,8.408,8.28c-0.363-3.385-1.383-8.066-3.979-13.456  c-0.803-1.664-1.729-3.263-2.751-4.752c-2.634-3.834-5.281-6.559-8.141-8.347C127.89,106.426,128.922,111.741,129.744,116.839z   M111.529,54.054c0.558,0.177,1.03,0.59,1.258,1.155c0.07,0.174,1.636,4.077,3.882,10.621c3.838-0.4,7.214-2.95,8.601-6.596  c0.984-2.592,0.885-5.418-0.249-7.917l-19.255,1.119c-0.242,0.759-0.394,1.532-0.455,2.315c1.73-0.267,3.461-0.524,5.196-0.771  c0.094-0.013,0.187-0.02,0.279-0.02C111.046,53.944,111.295,53.978,111.529,54.054z M79.613,180.085  c-4.121,0-8.605-0.879-13.709-2.687c-2.26-0.801-4.497-1.793-6.648-2.95c-14.295-7.688-19.11-17.327-19.308-17.734  c-0.36-0.74-0.229-1.626,0.329-2.231c0.558-0.605,1.431-0.806,2.199-0.506c0.096,0.037,9.702,3.75,19.639,4.028  c9.996,0.277,18-1.854,18.075-1.875c0.078-0.021,8.068-2.235,16.538-7.525c8.432-5.266,14.841-13.328,14.904-13.409  c0.512-0.647,1.365-0.914,2.153-0.675c0.788,0.24,1.349,0.938,1.412,1.759c0.035,0.451,0.757,11.202-7.686,25.064  c-1.271,2.086-2.699,4.074-4.243,5.908C95.793,176.127,88.497,180.085,79.613,180.085z M46.787,159.562  c2.7,3.195,7.268,7.546,14.364,11.363c1.972,1.06,4.021,1.969,6.089,2.702c4.668,1.654,8.715,2.458,12.374,2.458  c7.597,0,13.949-3.519,20.595-11.41c1.414-1.678,2.721-3.499,3.886-5.412c4.192-6.882,5.93-12.945,6.644-17.067  c-2.851,2.933-7.019,6.757-11.893,9.801c-8.995,5.618-17.262,7.899-17.61,7.993c-0.327,0.088-8.633,2.31-19.233,2.012  C56.258,161.842,50.729,160.651,46.787,159.562z M40.179,132.538c-0.349,0-0.698-0.091-1.011-0.274  c-3.261-1.91-5.601-4.966-6.589-8.605c-2.07-7.626,2.449-15.515,10.075-17.586c1.231-0.334,2.498-0.504,3.763-0.504  c6.447,0,12.131,4.35,13.823,10.579c0.052,0.191,0.092,0.383,0.13,0.575l0.036,0.174c0.167,0.775-0.14,1.576-0.783,2.041  l-18.271,13.22C41.003,132.411,40.591,132.538,40.179,132.538z M46.416,109.57c-0.912,0-1.825,0.123-2.715,0.364  c-5.497,1.493-8.755,7.18-7.262,12.677c0.601,2.21,1.893,4.122,3.692,5.493l16.033-11.601  C54.729,112.386,50.819,109.57,46.416,109.57z M101.759,115.817c-0.064,0-0.128-0.003-0.192-0.009l-22.448-2.163  c-0.79-0.076-1.46-0.612-1.708-1.366l-0.059-0.173c-0.063-0.182-0.125-0.365-0.176-0.553c-2.071-7.628,2.449-15.517,10.074-17.588  c1.231-0.334,2.497-0.504,3.763-0.504c6.447,0,12.131,4.35,13.823,10.579c0.988,3.64,0.515,7.46-1.332,10.756  C103.147,115.429,102.477,115.817,101.759,115.817z M80.869,109.795l19.699,1.898c0.858-2.092,1.006-4.396,0.406-6.606  c-1.219-4.49-5.316-7.626-9.962-7.626c-0.912,0-1.825,0.123-2.715,0.364C83.035,99.253,79.825,104.524,80.869,109.795z   M158.655,86.258c-1.738,0-3.45-0.315-5.089-0.938c-3.578-1.36-6.412-4.032-7.981-7.523c-1.568-3.492-1.683-7.385-0.322-10.963  c1.562-4.11,4.871-7.232,9.079-8.565c0.711-0.225,1.488-0.037,2.017,0.491l15.464,15.433c0.526,0.525,0.718,1.299,0.497,2.009  l-0.048,0.156c-0.066,0.218-0.134,0.436-0.216,0.652C169.952,82.543,164.568,86.258,158.655,86.258z M154.444,62.5  c-2.507,1.115-4.458,3.162-5.443,5.753c-0.98,2.58-0.897,5.386,0.233,7.903s3.174,4.443,5.754,5.423  c1.182,0.45,2.416,0.677,3.667,0.677c4.07,0,7.794-2.442,9.44-6.133L154.444,62.5z"
                          />
                        </svg>
                        <span class="cat-name">Arts & Entertainment</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Baby & Toddler')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="800px"
                          height="800px"
                          viewBox="0 0 960 960"
                          version="1.1"
                          xml:space="preserve"
                        >
                          <g class="f" id="guide" />

                          <g class="st0" id="sketch" />

                          <g class="st0" id="stroke">
                            <path
                              class="st2"
                              d="M422.2,462.3c175.5,55.9,315.9-152.4,191-279.7c-94.8-96.7-269.7-57.3-308.7,69.5   C278.3,337.1,333.6,434.1,422.2,462.3z"
                            />

                            <path
                              class="st2"
                              d="M298,296.1c43.2-0.3,86.4-15.6,119.5-43.5c34-28.6,55.9-77.2,62.6-124"
                            />

                            <path
                              class="st2"
                              d="M481.7,128.7c0,26.7,7.1,53.3,20.7,76.4c21.1,35.6,54.6,62.9,91.9,80.8c21,10.1,43.3,17.3,66,22.5"
                            />

                            <path
                              class="st2"
                              d="M413.6,313.4l-3.5-1c-7.3-1.2-15.2,4-16.8,11.3s3.1,15.4,10.2,17.5c7.1,2.1,15.6-2.2,18.1-9.2   C424.2,325,420.4,316.4,413.6,313.4z"
                            />

                            <path
                              class="st2"
                              d="M550.7,313.4l-3.5-1c-7.3-1.2-15.2,4-16.8,11.3c-1.7,7.3,3.1,15.4,10.2,17.5c7.1,2.1,15.6-2.2,18.1-9.2   C561.3,325,557.5,316.4,550.7,313.4z"
                            />

                            <path
                              class="st2"
                              d="M430.5,385.5c10.8,17.3,31.6,27.7,51.8,26.1c20.3-1.6,39.2-15.2,47.2-33.9"
                            />

                            <path
                              class="st2"
                              d="M299.2,276.4c-27.9,30-71.3,45.4-111.7,38.4c-46.8-8.1-87.1-45.8-98.4-92c20.5,2.4,40.6-7.4,57.2-19.6   c16.6-12.3,31.3-27.2,49.1-37.7c23.2-13.6,51.2-18.8,77.7-14.4c26,4.3,50.4,17.7,67.9,37.4"
                            />

                            <path
                              class="st2"
                              d="M618.8,188.6c17.5-19.8,42-33.3,68-37.6c26.5-4.4,54.5,0.8,77.7,14.4c17.8,10.5,32.5,25.4,49.1,37.7   c16.6,12.2,36.7,22.1,57.2,19.6c-11.2,46.2-51.5,83.9-98.4,92c-41.1,7.1-85.1-8.9-113-39.7l0,0"
                            />

                            <path
                              class="st2"
                              d="M564.7,450.5c15.4,31.5,28.5,64.8,39.5,98.1c17.1,51.8,29.2,103.7,36.9,148.8c0.6,3.3-11.8,6.5-32.2,9.1   c-17.2,2.2-40.1,4-65.9,5.1c-37.1,1.6-80.2,1.9-120.8,0c-24.7-1.1-48.5-3-69.5-5.9c-15.8-2.2-30-4.9-41.7-8.2   c15.5-53.1,28.3-102.2,42.9-149.6c10.1-32.6,21-64.4,34.2-96v0c0.5-1.2,1-2.5,1.6-3.7v0"
                            />

                            <path
                              class="st2"
                              d="M352.8,705.6c-5.2,27-8.7,54.4-10.5,81.8c-0.6,8.8-1,17.9,1.8,26.3c2.8,8.4,9.5,16,18.3,17.4   c7.6,1.2,15.3-2.6,20.7-8.2c5.3-5.6,8.7-12.7,11.8-19.7c12.7-29.3,22-60.2,27.5-91.7"
                            />

                            <path
                              class="st2"
                              d="M609,706.4c5.8,26.4,9.5,53.1,11.2,80.1c0.4,7.1,0.7,14.4-1.3,21.2c-2,6.8-6.8,13.2-13.6,15.4   c-7.7,2.5-16.4-1.1-22.1-6.9c-5.7-5.8-9-13.4-12.1-20.9c-11.2-27.3-20.5-55.3-28-83.9"
                            />

                            <path
                              class="st2"
                              d="M354,547.9c-15.9,3.1-31.8,6.2-47.7,9.4c-8.8,1.7-17.9,3.5-26.6,1.7c-8.8-1.8-17.3-7.9-19.1-16.7   c-2.4-12.4,8.7-22.9,18.9-30.3c33.7-24.3,70.2-44.5,108.7-60.1v0"
                            />

                            <path
                              class="st2"
                              d="M567.3,449.1c36.9,20.8,73.2,42.8,108.8,65.8c5.9,3.8,11.9,7.8,16.1,13.3c4.2,5.6,6.5,13.2,4,19.7   c-2.4,6.2-8.6,10.4-15,11.9c-6.5,1.6-13.2,0.9-19.8,0.1c-19.3-2.4-38.4-6.2-57.1-11.4"
                            />

                            <path
                              class="st2"
                              d="M389.7,448.2c-6.8,15.9,1.9,40.2,18.2,46.2c16.2,6,36.5-3.9,41.7-20.5c-3.6,12.6,1.2,27.1,11.7,35   s25.8,8.5,36.9,1.6c11.1-6.9,17.2-21,14.6-33.9c-0.5,11.8,8.8,23.1,20.4,25.5c11.6,2.4,24.2-3.7,30.2-13.9   c6-10.2,5.4-23.7-0.8-33.8"
                            />

                            <path
                              class="st2"
                              d="M543.5,578.7c1.6,16.9-0.6,27.4-5,38.6s-14.7,20.4-25.8,25c-12.5,5.2-24.3,6.8-37.8,6.1   c-12.6-0.7-24.5-3.8-35.7-9.6c-19.3-9.9-26-34.7-25.5-58.8C454.5,579.5,502.5,579.3,543.5,578.7z"
                            />
                          </g>

                          <g id="outline">
                            <path
                              d="M428.7,334.6c3.9-10.7-1.7-23.5-12.1-28.1c-0.3-0.1-0.6-0.2-0.9-0.3l-3.5-1c-0.3-0.1-0.6-0.2-0.9-0.2   c-11.2-1.9-22.8,5.9-25.4,17s4.5,23.2,15.4,26.4c1.9,0.6,3.9,0.8,5.9,0.8C416.5,349.2,425.5,343.4,428.7,334.6z M414.6,329.5   c-1.2,3.3-5.6,5.5-8.9,4.5c-3.3-1-5.8-5.3-5.1-8.6c0.7-3.1,4.2-5.6,7.4-5.6c0.2,0,0.4,0,0.6,0l2.4,0.7   C413.9,322,415.7,326.3,414.6,329.5z M553.7,306.5c-0.3-0.1-0.6-0.2-0.9-0.3l-3.5-1c-0.3-0.1-0.6-0.2-0.9-0.2   c-11.2-1.9-22.8,5.9-25.4,17c-2.5,11.1,4.5,23.2,15.4,26.4c1.9,0.6,3.9,0.8,5.9,0.8c9.2,0,18.2-5.8,21.4-14.6   C569.7,323.9,564.1,311,553.7,306.5z M551.7,329.5c-1.2,3.3-5.6,5.5-8.9,4.5c-3.3-1-5.8-5.3-5.1-8.6c0.7-3.1,4.2-5.6,7.4-5.6   c0.2,0,0.4,0,0.6,0l2.4,0.7C551,322,552.8,326.3,551.7,329.5z M536.4,380.7c-9,21.2-30.5,36.6-53.5,38.4c-1.5,0.1-3,0.2-4.6,0.2   c-21.5,0-42.8-11.6-54.2-29.8c-2.2-3.5-1.1-8.1,2.4-10.3c3.5-2.2,8.1-1.1,10.3,2.4c9.3,14.9,27.4,24,44.9,22.6   c17.5-1.4,33.9-13.2,40.8-29.3c1.6-3.8,6-5.6,9.8-4C536.3,372.5,538,376.9,536.4,380.7z M870,215.3c-15.5,1.8-32.9-4.3-51.9-18.2   c-6.1-4.5-12.1-9.5-17.9-14.4c-9.9-8.3-20.2-16.9-31.8-23.7c-24.5-14.4-54.7-20-82.7-15.4c-25.2,4.2-48.6,16.2-66.8,34.1   c-0.1-0.1-0.2-0.2-0.3-0.3c-23.9-24.4-54.4-41.8-88-50.2c-15.9-4-32.3-6-48.8-6c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0   c-0.4,0-0.8,0-1.1,0c-0.3,0-0.6,0-0.9,0c-15.7,0.2-31.4,2.1-46.8,5.9c-36.1,8.8-67.5,26.5-91.7,50.6c-18.1-17.9-41.5-29.8-66.7-34   c-28.1-4.6-58.2,1-82.8,15.4c-11.6,6.8-21.9,15.4-31.8,23.7c-5.8,4.9-11.8,9.9-17.9,14.4c-18.9,13.9-36.4,20.1-51.9,18.2   c-2.4-0.3-4.9,0.6-6.5,2.5s-2.3,4.4-1.7,6.7c11.9,48.9,54.8,89,104.4,97.6c6.8,1.2,13.7,1.8,20.7,1.8c29.7,0,59.9-10.6,83.6-29.3   c-0.3,29.6,7.6,59.6,23.4,87.6c15.2,27,37,49.9,62.5,66.5c-35.7,15.2-69.7,34.4-101.2,57.1c-6.3,4.6-25.6,18.5-21.9,37.8   c2.5,12.7,14.3,20.5,24.9,22.6c3.2,0.6,6.3,0.9,9.4,0.9c7.1,0,13.9-1.3,20.2-2.6l2.3-0.5c11-2.2,22-4.3,33.1-6.5   c-7.4,24.5-14.3,49.4-21.6,75.5c-5.6,20.1-11.4,40.9-17.6,62.2c-0.6,1.9-0.3,4,0.6,5.7s2.6,3,4.5,3.6c9.8,2.8,21.5,5.2,35,7.3   c-4.4,24.7-7.6,49.9-9.2,75c-0.7,9.9-1,19.6,2.2,29.2c4,11.9,13.5,20.7,24.2,22.4c1.3,0.2,2.6,0.3,3.9,0.3   c8.2,0,16.7-3.8,23.3-10.7c6.3-6.5,10-14.4,13.2-22c12.1-27.9,21.1-57.1,26.8-86.9c17.1,0.7,35.1,1,53.3,1   c18.6,0,37.4-0.4,55.6-1.1c7.3,26.7,16.3,53.3,26.8,79c3.5,8.5,7.1,16.7,13.7,23.3c6.3,6.4,14.4,9.9,22.3,9.9c2.5,0,5-0.4,7.4-1.1   c8.6-2.8,15.5-10.4,18.5-20.4c2.4-7.9,2.1-15.8,1.6-23.8c-1.5-24.5-4.8-49.1-9.7-73.3c22.3-3.4,26.7-6.8,28.9-9.8   c1.5-2,2.1-4.5,1.7-6.9c-7.9-46.1-19.3-93.1-33-136.8c14.8,3.6,29.8,6.3,44.8,8.2c3.9,0.5,7.9,0.9,11.9,0.9c3.5,0,7-0.3,10.6-1.2   c9.7-2.3,17.2-8.5,20.3-16.5c3.2-8.3,1.2-18.7-5.1-26.9c-5.1-6.8-12.3-11.4-18-15.1c-32.1-20.8-65-40.8-98.1-59.8   c23.7-15.5,44.1-36.3,59.1-60.7c18.2-29.5,27.5-62,27.2-94.5c23.8,19.4,54.4,30.3,84.7,30.3c7,0,13.9-0.6,20.8-1.8   c49.5-8.6,92.5-48.7,104.4-97.6c0.6-2.4,0-4.9-1.7-6.7C874.9,216,872.5,215.1,870,215.3z M436.3,141.6c11.5-2.8,23.2-4.5,34.9-5.2   c-8.3,45.5-29.9,86.3-58.6,110.4c-29.3,24.6-68,39.5-107.1,41.5c0.2-3.6,0.5-7.1,1-10.6c0.1-0.4,0.1-0.7,0.1-1.1   c1-7.6,2.7-15,4.9-22.4C328.8,198.6,375.4,156.5,436.3,141.6z M292.1,272.9c-26.5,27.3-66.8,40.8-103.3,34.4   c-40.6-7-76.1-38-89.6-76.8c16.3-1,33.6-8.1,51.6-21.4c6.5-4.8,12.7-10,18.7-15c9.9-8.3,19.3-16.1,29.8-22.3   c21.6-12.7,48.1-17.6,72.7-13.5c22.3,3.7,42.9,14.3,58.9,30.2c-15.1,17.8-26.6,38.5-33.6,61.3C295,257.5,293.3,265.2,292.1,272.9z    M307.2,549.4l-2.3,0.5c-8,1.6-16.3,3.2-23.7,1.7c-5.5-1.1-12-5-13.2-10.8c-1.3-6.6,4.1-14.2,15.9-22.7   c28.3-20.4,58.7-37.9,90.5-52.1c-9,22.8-17.5,47.3-26.3,75.5C334.5,544,320.8,546.7,307.2,549.4z M388,800.2   c-2.7,6.3-5.7,12.8-10.3,17.5c-4.2,4.4-9.6,6.7-14.1,6c-6-0.9-10.5-6.9-12.3-12.3c-2.3-6.9-2-15-1.5-23.4c1.7-24.8,4.7-49.6,9.1-74   c16.2,2,34.5,3.5,54.4,4.6C407.9,746.6,399.3,774,388,800.2z M611.7,805.6c-1.2,4.1-4.1,9-8.7,10.4c-5,1.6-10.8-1.3-14.4-5   c-4.6-4.7-7.6-11.4-10.5-18.5c-9.8-24.1-18.3-48.9-25.3-74c19-1,36.1-2.3,50.3-3.9c4.9,23.8,8.1,48.1,9.6,72.3   C613.1,793.6,613.3,800,611.7,805.6z M633.1,694.3c-3.2,1.1-10.3,2.8-25,4.7c-17.1,2.2-39.7,3.9-65.3,5c0,0,0,0-0.1,0c0,0,0,0,0,0   c-39.8,1.7-82.4,1.7-120,0c-25.9-1.2-49.1-3.2-68.8-5.8c-12.7-1.7-23.9-3.8-33.4-6.1c5.4-18.8,10.5-37.1,15.5-54.9   c8.5-30.3,16.5-58.9,25.2-87.1c0,0,0,0,0,0c7.9-25.6,15.6-48.1,23.5-69c4.6,9.8,12.1,17.2,20.7,20.4c9.7,3.6,20.9,2.8,30.9-2.1   c2.4-1.2,4.6-2.6,6.7-4.1c2.5,7.7,7.3,14.7,13.8,19.7c7,5.3,15.6,7.9,24.2,7.9c7.4,0,14.8-2,21.2-6c6-3.8,10.8-9.2,14.1-15.4   c4.3,3.9,9.6,6.7,15.5,8c14.4,3,30.5-4.4,38.2-17.5c1.1-2,2.1-4,2.9-6.1c8.8,20.5,17,42.3,24.5,65.1c0,0,0,0,0,0   C612.1,596.2,624.5,645.7,633.1,694.3z M394.9,459.3c8.1,4,16.4,7.4,25,10.1c7,2.2,14.1,4.1,21.2,5.6c-2.3,4.5-6.4,8.4-11.5,10.9   c-6.3,3.1-13.3,3.6-19.1,1.5c-5.2-1.9-9.9-6.9-12.8-13.7C395.7,469,394.8,463.9,394.9,459.3z M456.4,477.6c8.1,1,16.2,1.6,24.3,1.6   c8.3,0,16.5-0.6,24.6-1.6c0,2,0.2,4,0.6,6c-0.3,8.2-4.7,16.4-11.7,20.7c-8.5,5.3-20.4,4.8-28.4-1.2   C458.2,497.3,454.5,486.8,456.4,477.6z M520.1,474.9c10.3-2.3,20.5-5.4,30.4-9.4c2.6-1,5.1-2.2,7.6-3.3c2.9,7.3,2.6,15.8-1.2,22.2   c-4.5,7.6-14,12.1-22.2,10.4c-6.5-1.4-12.1-6.8-13.8-13c0-2.2-0.3-4.4-0.7-6.5C520.1,475.1,520.1,475,520.1,474.9z M672,521.2   c5.2,3.4,10.7,6.9,14.2,11.6c3.1,4.1,4.3,9,3,12.5c-1.3,3.3-5,6.1-9.8,7.3c-5.3,1.3-11.1,0.7-17.2,0c-17.6-2.2-35.1-5.6-52.2-10.2   c-9.2-27.4-19.4-53.4-30.3-77.5C610.9,482.8,641.9,501.7,672,521.2z M628.4,380.3c-19.7,32-49.4,57.3-83.6,71.3   c-37.7,15.4-79.3,16.6-120.3,3.6c-40.6-12.9-76.2-42.2-97.6-80.3c-12.9-22.9-20.1-47.3-21.3-71.4c42.6-2,84.8-18.2,116.8-45   c25.1-21.1,45.1-53.6,56.7-90.8c3.6,14.5,9.3,28.4,16.9,41.3c20.6,34.8,53.5,63.8,95.1,83.7c18.5,8.9,39,16.1,61.2,21.5   C649.3,336.9,641.3,359.4,628.4,380.3z M653.3,298.9c-20.2-5.1-38.9-11.8-55.8-19.9c-38.9-18.6-69.6-45.6-88.6-77.8   c-11.6-19.6-18.2-41.9-19.4-64.9c12.7,0.5,25.3,2.3,37.5,5.4c30.9,7.8,58.9,23.7,80.9,46.2c27,27.5,42.6,60.9,45.1,96.5   C653.3,289.2,653.4,294,653.3,298.9z M771.3,307.4c-37.3,6.5-78.1-7.5-104.6-35.7c-4.4-30-17.2-58.2-37.7-82.8   c15.9-15.8,37.1-26.8,59.1-30.4c24.6-4.1,51.2,0.9,72.7,13.5c10.5,6.2,19.9,14,29.8,22.3c6,5,12.2,10.2,18.7,15   c18,13.2,35.3,20.4,51.6,21.3C847.4,269.4,811.8,300.3,771.3,307.4z M543.4,571.2c-20.5,0.3-43.1,0.5-64.9,0.7   c-21.9,0.2-44.5,0.4-65,0.7c-4,0.1-7.3,3.3-7.4,7.3c-0.7,31.8,10.1,55.7,29.5,65.6c11.9,6.1,25,9.6,38.7,10.4   c2.2,0.1,4.4,0.2,6.5,0.2c12.5,0,23.4-2.2,34.7-6.8c13.7-5.7,24.9-16.6,29.9-29.2c4.6-11.7,7.4-23.3,5.5-42.1   C550.6,574.1,547.3,571.1,543.4,571.2z M531.5,614.5c-3.5,8.8-11.8,16.8-21.7,20.9c-10.9,4.5-21.6,6.2-34.6,5.5   c-11.8-0.7-22.5-3.5-32.7-8.7c-16.8-8.6-20.6-30.6-21.3-44.7c18.4-0.2,38.2-0.4,57.4-0.6c19.4-0.2,39.3-0.3,57.9-0.6   C536.9,598.2,534.8,606.1,531.5,614.5z"
                            />
                          </g>

                          <g class="st0" id="flat">
                            <g class="st3">
                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st12"
                                                d="M422.3,711.5c-5.5,31.5-14.7,62.4-27.4,91.7c-3.1,7.1-6.4,14.2-11.8,19.7            c-5.3,5.6-13.1,9.4-20.7,8.2c-8.8-1.4-15.5-9-18.3-17.4c-2.8-8.4-2.4-17.5-1.8-26.3c1.8-27.5,5.4-54.8,10.5-81.8            C376.7,694.1,400.2,697.3,422.3,711.5z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st12"
                                                d="M618.9,807.7c-2,6.8-6.8,13.2-13.6,15.4c-7.7,2.5-16.4-1.1-22.1-6.8c-5.7-5.8-9-13.4-12.1-20.9            c-11.2-27.3-20.5-55.3-28-83.9c20.9-15.5,43.8-17.2,65.9-5.1c5.8,26.4,9.5,53.2,11.2,80.1            C620.6,793.6,620.9,800.9,618.9,807.7z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st12"
                                                d="M389.7,448.2c-1.2,34.3-12.8,70-35.8,99.7c-15.9,3.1-31.8,6.2-47.7,9.4c-8.8,1.7-17.9,3.5-26.7,1.7            c-8.8-1.8-17.3-7.9-19.1-16.7c-2.4-12.4,8.7-22.9,18.9-30.3C313.1,487.7,351.3,463.8,389.7,448.2z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st12"
                                                d="M696.2,548c-2.4,6.2-8.6,10.4-15,11.9c-6.5,1.6-13.2,0.9-19.9,0.1c-19.3-2.4-38.4-6.2-57.1-11.4            c-27.5-18.8-31.4-34-42.1-91.2c-0.5-1.4,0.4-4.4,2.5-6.9c0.9-0.4,75.8,41.4,111.4,64.4c5.9,3.8,11.9,7.8,16.1,13.3            C696.5,533.8,698.7,541.4,696.2,548z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st9"
                                                d="M641.2,697.3c-7.7-45.1-19.8-96.9-36.9-148.8c-10.6-32-24.9-67.8-39.6-98.1l-175-2.3            c0,0-1.1,2.5-1.6,3.7v0c-13.2,31.6-24.1,63.4-34.2,96c-14.6,47.4-27.4,96.5-42.9,149.5c11.7,3.3,25.9,6,41.8,8.2            c20.9,2.9,44.7,4.8,69.5,5.9c40.6,1.9,83.6,1.6,120.8,0c25.8-1.1,48.7-2.9,65.9-5.1C629.4,703.8,641.8,700.6,641.2,697.3z            "
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st12"
                                                d="M481.7,128.7c-0.5,0-1.1,0-1.6,0c-6.7,46.7-138.9,167.2-182.2,167.5c0.1,60.8,36.2,120.8,91.8,152            c10.2,5.8,21,10.5,32.4,14.2c9.7,3.1,19.2,5.4,28.7,6.9c42,6.8,81.1-1.1,113.9-18.8c0.9-0.4,1.7-0.9,2.5-1.4            c52.4-29.2,88.2-83.3,93-140.8C637.5,303.1,481.7,155.3,481.7,128.7z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <path
                                              class="st8"
                                              d="M813.7,203.2c-16.6-12.3-31.3-27.2-49.1-37.7c-23.2-13.6-51.2-18.8-77.7-14.4           c-26.1,4.3-50.5,17.8-68,37.6c-1.8-2-3.7-4-5.6-6c-36.2-36.9-84-54-131.5-54c-52.3,0.4-105.5,21.6-140.7,59.8           c-17.5-19.7-41.9-33.1-67.9-37.4c-26.5-4.4-54.6,0.8-77.7,14.4c-17.8,10.5-32.5,25.4-49.1,37.7           c-16.6,12.2-36.7,22.1-57.2,19.6c11.2,46.1,51.6,83.8,98.4,92c40.5,7,83.9-8.4,111.8-38.4c-0.9,6.6-1.3,13.2-1.3,19.8           c43.2-0.3,86.4-15.6,119.6-43.5c22.7-19,48.9-47,61.9-77.3c21.9,60,89.6,125.2,180.9,132.9c0.9-11,0.7-22.1-0.7-33.2           c27.8,30.8,71.9,46.9,113,39.7c46.8-8.1,87.1-45.8,98.4-92C850.4,225.2,830.3,215.4,813.7,203.2z"
                                            />
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <g>
                                                <path
                                                  class="st6"
                                                  d="M389.7,448.2c-7.6,15.7-1.5,40,18.2,46.2c16.5,5.2,37.8-8.7,43-25.2c-9.4-1.5-19-3.8-28.7-6.9             C410.8,458.7,399.9,453.9,389.7,448.2z"
                                                />
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>

                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <g>
                                                <path
                                                  class="st6"
                                                  d="M566.6,454.3c-0.6-1.3-1.2-2.6-1.9-3.9c-32.8,17.6-71.9,25.6-113.9,18.8c-3.6,12.6,0,31.9,10.4,39.7             c10.4,7.9,26.1,7.1,36.9-0.4c11.7-8.2,14.3-26.1,14.2-39.7c2,11.8,6.5,24.9,20.8,30.3c11.1,4.2,24.2-0.7,30.2-10.9             C568.6,479.2,570.5,464.6,566.6,454.3z"
                                                />
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st6"
                                                d="M538.4,617.3c-4.4,11.2-14.7,20.4-25.8,25c-12.5,5.2-24.3,6.8-37.8,6.1c-12.6-0.7-24.5-3.8-35.7-9.5            c-19.3-9.9-26-34.7-25.5-58.8c41-0.6,88.9-0.8,129.9-1.3C545.1,595.6,542.9,606.1,538.4,617.3z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st7"
                                                d="M421.6,332c-2.5,7-10.9,11.3-18.1,9.2c-7.1-2.1-11.9-10.2-10.2-17.5c1.7-7.3,9.5-12.5,16.8-11.3            l3.5,1C420.4,316.4,424.2,325,421.6,332z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st7"
                                                d="M558.7,332c-2.5,7-10.9,11.3-18.1,9.2c-7.1-2.1-11.9-10.2-10.2-17.5c1.7-7.3,9.5-12.5,16.8-11.3            l3.5,1C557.5,316.4,561.3,325,558.7,332z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st7"
                                                d="M478.4,419.3c-21.5,0-42.8-11.6-54.2-29.8c-2.2-3.5-1.1-8.1,2.4-10.3c3.5-2.2,8.1-1.1,10.3,2.4            c9.3,14.9,27.4,24,44.9,22.6c17.5-1.4,33.9-13.2,40.8-29.3c1.6-3.8,6-5.6,9.8-4c3.8,1.6,5.6,6,4,9.8            c-9,21.2-30.5,36.6-53.5,38.4C481.4,419.2,479.9,419.3,478.4,419.3z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st7"
                                                d="M299.2,283.8c-0.3,0-0.6,0-1-0.1c-4.1-0.5-7-4.3-6.5-8.4c1.1-8.6,3-17.2,5.5-25.5            c7.7-24.9,20.5-47.3,38.2-66.5c2.8-3,7.5-3.2,10.6-0.4c3,2.8,3.2,7.5,0.4,10.6c-16.2,17.6-27.9,38-34.9,60.8            c-2.3,7.5-4,15.2-5,23C306.2,281.1,302.9,283.8,299.2,283.8z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>

                              <g>
                                <g>
                                  <g>
                                    <g>
                                      <g>
                                        <g>
                                          <g>
                                            <g>
                                              <path
                                                class="st7"
                                                d="M659.6,282.5c-3.7,0-6.9-2.8-7.4-6.5c-3.9-30.3-17-58.1-38.9-82.4c-2.8-3.1-2.5-7.8,0.6-10.6            c3.1-2.8,7.8-2.5,10.6,0.6c23.9,26.6,38.3,57.1,42.6,90.5c0.5,4.1-2.4,7.9-6.5,8.4C660.2,282.5,659.9,282.5,659.6,282.5z"
                                              />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>

                          <g class="st0" id="colored_x5F_line">
                            <g class="st3">
                              <path
                                class="st8"
                                d="M813.7,203.2c-16.6-12.3-31.3-27.2-49.1-37.7c-23.2-13.6-51.2-18.8-77.7-14.4c-26.1,4.3-50.5,17.8-68,37.6    c-1.8-2-3.7-4-5.6-6c-36.2-36.9-84-54-131.5-54c-52.3,0.4-105.5,21.6-140.7,59.8c-17.5-19.7-41.9-33.1-67.9-37.4    c-26.5-4.4-54.6,0.8-77.7,14.4c-17.8,10.5-32.5,25.4-49.1,37.7c-16.6,12.2-36.7,22.1-57.2,19.6c11.2,46.1,51.6,83.8,98.4,92    c40.5,7,83.9-8.4,111.8-38.4c-0.9,6.6-1.3,13.2-1.3,19.8c43.2-0.3,86.4-15.6,119.6-43.5c22.7-19,48.9-47,61.9-77.3    c21.9,60,89.6,125.2,180.9,132.9c0.9-11,0.7-22.1-0.7-33.2c27.8,30.8,71.9,46.9,113,39.7c46.8-8.1,87.1-45.8,98.4-92    C850.4,225.2,830.3,215.4,813.7,203.2z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st16"
                                d="M413.6,313.4l-3.5-1c-7.3-1.2-15.2,4-16.8,11.3s3.1,15.4,10.2,17.5c7.1,2.1,15.6-2.2,18.1-9.2    C424.2,325,420.4,316.4,413.6,313.4z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st16"
                                d="M550.7,313.4l-3.5-1c-7.3-1.2-15.2,4-16.8,11.3c-1.7,7.3,3.1,15.4,10.2,17.5c7.1,2.1,15.6-2.2,18.1-9.2    C561.3,325,557.5,316.4,550.7,313.4z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st16"
                                d="M478.4,419.3c-21.5,0-42.8-11.6-54.2-29.8c-2.2-3.5-1.1-8.1,2.4-10.3c3.5-2.2,8.1-1.1,10.3,2.4    c9.3,14.9,27.4,24,44.9,22.6c17.5-1.4,33.9-13.2,40.8-29.3c1.6-3.8,6-5.6,9.8-4c3.8,1.6,5.6,6,4,9.8c-9,21.2-30.5,36.6-53.5,38.4    C481.4,419.2,479.9,419.3,478.4,419.3z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st8"
                                d="M514.6,488.9c0.2-0.9,0.3-1.9,0.4-2.9C514.6,487,514.5,488,514.6,488.9z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st8"
                                d="M641.2,697.3c-7.7-45.1-19.8-96.9-36.9-148.8c-9.4-28.4-20.3-56.8-32.9-84.1c-3.4,15.8-9.2,30.9-25.4,36.5    c-9,3-19,3-25-4c-2.4-2.4-4.8-4.7-6.4-8.1c-2.2,11.2-11.4,17.4-20.6,21.1c-19,8-44-3-47-24c-8,7-20,13-32,11    c-20.9-2.2-27.3-21.2-28.8-40.3c-12.3,30-22.7,60.2-32.2,91.2c-14.6,47.4-27.4,96.5-42.9,149.6c11.7,3.3,25.9,6,41.7,8.2    c20.9,2.9,44.7,4.8,69.5,5.9c40.6,1.9,83.6,1.6,120.8,0c25.8-1.1,48.7-2.9,65.9-5.1C629.4,703.8,641.8,700.7,641.2,697.3z     M538.4,617.3c-4.5,11.2-14.7,20.4-25.8,25c-12.5,5.2-24.3,6.8-37.8,6.1c-12.6-0.7-24.5-3.8-35.7-9.6c-19.3-9.9-26-34.7-25.5-58.8    c41-0.6,89-0.8,129.9-1.4C545.1,595.6,542.9,606.1,538.4,617.3z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st16"
                                d="M365.2,838.8c-1.3,0-2.6-0.1-3.9-0.3c-10.7-1.7-20.2-10.5-24.2-22.4c-3.2-9.5-2.9-19.2-2.2-29.2    c1.9-27.7,5.4-55.6,10.7-82.8c0.8-4.1,4.7-6.7,8.8-6c4.1,0.8,6.7,4.7,6,8.8c-5.1,26.6-8.6,53.8-10.4,80.9    c-0.6,8.4-0.9,16.5,1.5,23.4c1.8,5.5,6.4,11.4,12.3,12.3c4.5,0.7,9.9-1.6,14.1-6c4.5-4.7,7.6-11.2,10.3-17.5    c12.5-28.8,21.5-59.1,26.9-90c0.7-4.1,4.6-6.8,8.7-6.1c4.1,0.7,6.8,4.6,6.1,8.7c-5.6,32.1-15,63.5-28,93.4    c-3.3,7.5-7,15.4-13.2,22C381.9,835,373.4,838.8,365.2,838.8z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st16"
                                d="M600.1,831.4c-7.8,0-16-3.5-22.3-9.9c-6.6-6.6-10.2-14.8-13.7-23.3c-11.3-27.5-20.8-56.1-28.4-84.8    c-1.1-4,1.3-8.1,5.3-9.2c4-1.1,8.1,1.3,9.2,5.3c7.4,28.1,16.7,56,27.7,82.9c2.9,7.1,5.8,13.8,10.5,18.5c3.6,3.6,9.4,6.6,14.4,5    c4.5-1.5,7.5-6.3,8.7-10.4c1.7-5.6,1.4-12,1-18.6c-1.6-26.4-5.3-53-11-78.9c-0.9-4,1.7-8,5.7-8.9c4-0.9,8,1.7,8.9,5.7    c5.8,26.7,9.7,54,11.3,81.2c0.5,8,0.7,15.9-1.6,23.8c-3,10-9.9,17.7-18.5,20.4C605.2,831,602.7,831.4,600.1,831.4z"
                              />
                            </g>

                            <g class="st3">
                              <path
                                class="st16"
                                d="M480.9,656.1c-2.1,0-4.3-0.1-6.5-0.2c-13.8-0.8-26.8-4.2-38.7-10.4c-19.4-10-30.2-33.9-29.5-65.6    c0.1-4,3.4-7.3,7.4-7.3c20.5-0.3,43.1-0.5,65-0.7c21.9-0.2,44.5-0.4,64.9-0.7c3.9-0.1,7.2,2.9,7.6,6.8c1.8,18.8-0.9,30.4-5.5,42.1    c-5,12.6-16.2,23.5-29.9,29.2C504.3,653.9,493.4,656.1,480.9,656.1z M421.2,587.5c0.7,14.1,4.5,36.1,21.3,44.7    c10.2,5.2,20.9,8.1,32.7,8.7c13,0.7,23.6-1,34.6-5.5c9.9-4.1,18.2-12.1,21.7-20.9c3.3-8.4,5.4-16.4,5-28.2    c-18.6,0.2-38.5,0.4-57.9,0.6C459.4,587.1,439.6,587.2,421.2,587.5z"
                              />
                            </g>

                            <path
                              class="st17"
                              d="M698.2,523.7c-5.1-6.8-12.3-11.4-18-15.1c-32.1-20.8-65-40.8-98.1-59.8c23.7-15.5,44.1-36.3,59.1-60.7   c20.1-32.6,29.3-68.9,26.7-104.9c-2.8-39.2-19.9-75.8-49.4-105.9c-23.9-24.4-54.4-41.8-88-50.2c-31.6-7.9-65.4-8-97.8-0.1   c-66.1,16.1-116.8,62-135.5,122.8c-13.2,43-7.4,90,16.5,132.3c15.2,27,37,49.9,62.5,66.5c-35.7,15.2-69.7,34.4-101.2,57.1   c-6.3,4.6-25.6,18.5-21.9,37.8c2.5,12.7,14.3,20.5,24.9,22.6c3.2,0.6,6.3,0.9,9.4,0.9c7.1,0,13.9-1.3,20.2-2.6l2.3-0.5   c15.1-3,30.2-5.9,45.3-8.9c4.1-0.8,6.7-4.7,5.9-8.8c-0.8-4.1-4.7-6.7-8.8-5.9c-15.1,3-30.2,5.9-45.3,8.9l-2.3,0.5   c-8,1.6-16.3,3.2-23.7,1.7c-5.5-1.1-12-5-13.2-10.8c-1.3-6.6,4.1-14.2,15.9-22.7c30-21.6,62.3-39.9,96.1-54.6   c0.4,5.4,1.7,10.9,3.9,16.1c4.5,10.5,12.3,18.5,21.4,21.9c9.7,3.6,20.9,2.8,30.9-2.1c2.4-1.2,4.6-2.6,6.7-4.1   c2.5,7.7,7.3,14.7,13.8,19.7c7,5.3,15.6,7.9,24.2,7.9c7.4,0,14.8-2,21.2-6c5.9-3.7,10.5-9.2,13.7-15.8c4.3,4.2,9.7,7.1,15.8,8.3   c14.4,3,30.5-4.4,38.2-17.5c5.3-9.1,6.6-20.3,3.8-30.7c33.2,19,66.3,39.1,98.5,59.9c5.2,3.4,10.7,6.9,14.2,11.6   c3.1,4.1,4.3,9,3,12.5c-1.3,3.3-5,6.1-9.8,7.3c-5.3,1.3-11.1,0.7-17.2,0c-18.9-2.3-37.7-6.1-56-11.2c-4-1.1-8.1,1.2-9.2,5.2   c-1.1,4,1.2,8.1,5.2,9.2c19,5.3,38.6,9.2,58.2,11.6c3.9,0.5,7.9,0.9,11.9,0.9c3.5,0,7-0.3,10.6-1.2c9.7-2.3,17.2-8.5,20.3-16.5   C706.4,542.3,704.5,532,698.2,523.7z M429.6,485.9c-6.3,3.1-13.3,3.6-19.1,1.5c-5.2-1.9-9.9-6.9-12.8-13.7c-2-4.7-3-9.7-2.8-14.3   c8.1,4,16.4,7.4,25,10.1c7,2.2,14.1,4.1,21.2,5.6C438.7,479.5,434.7,483.4,429.6,485.9z M494.2,504.2c-8.5,5.3-20.4,4.8-28.4-1.2   c-7.5-5.7-11.3-16.1-9.4-25.4c8.1,1,16.2,1.6,24.3,1.6c8.3,0,16.5-0.6,24.6-1.6C505.9,486.8,503.2,498.5,494.2,504.2z M556.9,484.4   c-4.5,7.6-14,12.1-22.2,10.4c-8.1-1.7-13.8-9-14.4-18.6c0-0.4-0.1-0.9-0.2-1.3c10.3-2.3,20.5-5.4,30.4-9.4c2.6-1,5.1-2.2,7.6-3.3   C561,469.5,560.6,478,556.9,484.4z M544.8,451.6c-37.7,15.4-79.3,16.6-120.3,3.6c-40.6-12.9-76.2-42.2-97.6-80.3   c-21.8-38.7-27.2-81.5-15.2-120.5c17.1-55.7,63.7-97.9,124.7-112.7c30-7.3,61.3-7.3,90.6,0.1c30.9,7.8,58.9,23.7,80.9,46.2   c27,27.5,42.6,60.9,45.1,96.5c2.4,32.9-6.1,66-24.6,96C608.7,412.3,579,437.6,544.8,451.6z"
                            />
                          </g>
                        </svg>
                        <span class="cat-name">Baby & Toddler</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Business & Industrial')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512 512"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M471.149,87.149h-99.448c-2.466-6.952-7.983-12.469-14.935-14.935V8.17c0-4.513-3.657-8.17-8.17-8.17H163.404    c-4.513,0-8.17,3.657-8.17,8.17v64.044c-6.952,2.466-12.469,7.983-14.935,14.935H40.851C18.325,87.149,0,105.474,0,128v343.149    C0,493.675,18.325,512,40.851,512h430.298C493.675,512,512,493.675,512,471.149V128C512,105.474,493.675,87.149,471.149,87.149z     M171.574,16.34h168.851v16.34H171.574V16.34z M171.574,49.021h168.851v38.128H171.574V49.021z M40.851,495.66    c-13.515,0-24.511-10.996-24.511-24.511v-56.804c43.046,3.9,77.414,38.268,81.314,81.314H40.851z M495.66,471.149    c0,13.515-10.996,24.511-24.511,24.511h-56.804c3.9-43.046,38.268-77.414,81.314-81.314V471.149z M495.66,226.043    c0,13.515-10.996,24.511-24.511,24.511H296.851v-40.851c0-4.513-3.657-8.17-8.17-8.17h-65.362c-4.513,0-8.17,3.657-8.17,8.17    v98.043c0,22.526,18.325,40.851,40.851,40.851s40.851-18.325,40.851-40.851v-40.851h174.298c9.19,0,17.678-3.051,24.511-8.192    v139.227c-52.066,3.979-93.752,45.665-97.731,97.731H114.071c-3.979-52.066-45.665-93.752-97.731-97.731V258.702    c6.832,5.141,15.321,8.192,24.511,8.192h149.787c4.513,0,8.17-3.657,8.17-8.17c0-4.513-3.657-8.17-8.17-8.17H40.851    c-13.515,0-24.511-10.996-24.511-24.511V128c0-13.515,10.996-24.511,24.511-24.511h430.298c13.515,0,24.511,10.996,24.511,24.511    V226.043z M231.489,283.234v-65.362h49.021v65.362H231.489z M280.511,299.574v8.17c0,13.515-10.996,24.511-24.511,24.511    c-13.515,0-24.511-10.996-24.511-24.511v-8.17H280.511z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <circle cx="49.021" cy="136.17" r="8.17" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <circle cx="81.702" cy="168.851" r="8.17" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <circle cx="430.298" cy="381.277" r="8.17" />
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Business & Industrial</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Cameras & Optics')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="800px"
                          height="800px"
                          viewBox="0 0 48 48"
                          id="Layer_2"
                          data-name="Layer 2"
                        >
                          <path
                            class="cls-1"
                            d="M19.83,8.77l-2.77,2.84H6.29A1.79,1.79,0,0,0,4.5,13.4V36.62a1.8,1.8,0,0,0,1.79,1.8H41.71a1.8,1.8,0,0,0,1.79-1.8V13.4a1.79,1.79,0,0,0-1.79-1.79H30.94L28.17,8.77Zm18.93,5.74a1.84,1.84,0,1,1,0,3.68A1.84,1.84,0,0,1,38.76,14.51ZM24,17.71a8.51,8.51,0,1,1-8.51,8.51A8.51,8.51,0,0,1,24,17.71Z"
                          />
                        </svg>
                        <span class="cat-name">Cameras & Optics</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Electronics')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          width="800px"
                          height="800px"
                          viewBox="0 0 512 512"
                          enable-background="new 0 0 512 512"
                          id="computer_x5F_desk_1_"
                          version="1.1"
                          xml:space="preserve"
                        >
                          <g id="computer_x5F_desk">
                            <path
                              d="M168.651,260.609H65.247v67.813h103.404V260.609z M161.451,321.222H72.447v-53.411h89.004V321.222z"
                            />

                            <path
                              d="M168.651,369.222H65.247v67.8h103.404V369.222z M161.451,429.822H72.447v-53.4h89.004V429.822z"
                            />

                            <path
                              d="M462.123,206.601H338.977v-17.467h57.955c3.73,0,6.766-3.035,6.766-6.767V87.176c0-3.731-3.035-6.766-6.766-6.766H221.823   c-3.731,0-6.767,3.035-6.767,6.766v95.191c0,3.731,3.035,6.767,6.767,6.767h57.954v17.467H114.824l-31.071-62.928   c2.124-2.365,3.429-5.479,3.429-8.901c0-3.089-1.065-5.93-2.834-8.195l23.331-34.552l27.93,22.391   c1.063,0.853,2.372,1.306,3.71,1.306c0.374,0,0.75-0.036,1.124-0.107c1.712-0.329,3.187-1.387,4.046-2.904l21.066-37.195   c0.871-1.54,1.012-3.372,0.386-5.026c-0.626-1.654-1.943-2.934-3.615-3.511l-45.397-15.672c-2.705-0.936-5.693,0.195-7.104,2.686   L96.829,76.933c-1.443,2.548-0.832,5.727,1.453,7.558l3.76,3.014l-23.492,34.793c-1.469-0.558-3.055-0.877-4.718-0.877   c-7.361,0-13.35,5.989-13.35,13.35c0,7.361,5.989,13.35,13.35,13.35c1.325,0,2.602-0.2,3.811-0.561l29.152,59.04H49.877   c-4.762,0-8.636,3.874-8.636,8.636v28.575h0.006v101.411v7.2v100.02c0,4.731,3.849,8.58,8.581,8.58h134.244   c4.73,0,8.58-3.849,8.58-8.58v-100.02v-7.2V243.811h251.64v208.777c0,4.65,3.783,8.434,8.434,8.434h9.6   c4.65,0,8.435-3.783,8.435-8.434V243.811v-1.6v-26.975C470.759,210.474,466.885,206.601,462.123,206.601z M115.57,58.453   l42.97,14.834l-19.586,34.583l-35.33-28.324L115.57,58.453z M73.832,140.922c-3.391,0-6.15-2.759-6.15-6.15   c0-3.391,2.759-6.15,6.15-6.15c3.392,0,6.15,2.759,6.15,6.15C79.981,138.163,77.223,140.922,73.832,140.922z M222.257,181.934   V87.609h174.241v94.324h-57.521v-0.312h-59.199v0.312H222.257z M331.777,189.134v17.467h-44.801v-17.467H331.777z M185.451,452.441   c0,0.762-0.619,1.381-1.38,1.381H49.828c-0.761,0-1.38-0.619-1.38-1.381v-100.02h137.004V452.441z M185.451,345.222H48.447V243.811   h137.004V345.222z M463.559,452.588c0,0.681-0.554,1.234-1.234,1.234h-9.6c-0.68,0-1.233-0.554-1.233-1.234V243.811h12.067V452.588   z M463.559,236.611h-13.668h-257.24v-0.001H48.441v-21.374c0-0.792,0.644-1.436,1.436-1.436h229.9h59.199h123.146   c0.791,0,1.436,0.644,1.436,1.436V236.611z"
                            />

                            <path
                              d="M374.055,365.885H253.031l-18.152-51.053l-6.784,2.411l18.795,52.863v83.7c0,3.979,3.237,7.215,7.215,7.215H372.98   c3.979,0,7.215-3.236,7.215-7.215v-83.7l18.796-52.863l-6.784-2.411L374.055,365.885z M372.98,453.822H254.105l-0.015-80.736   h118.904L372.98,453.822z"
                            />

                            <path
                              d="M281.979,407.2h63.127c2.563,0,4.647-2.085,4.647-4.647v-11.816c0-2.563-2.085-4.646-4.647-4.646h-63.127   c-2.562,0-4.647,2.084-4.647,4.646v11.816C277.332,405.115,279.418,407.2,281.979,407.2z M284.533,393.289h58.021V400h-58.021   V393.289z"
                            />

                            <rect
                              height="7.199"
                              width="16.2"
                              x="107.691"
                              y="290.916"
                            />

                            <rect
                              height="7.2"
                              width="16.2"
                              x="107.691"
                              y="400"
                            />
                          </g>
                        </svg>
                        <span class="cat-name">Electronics</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a
                        @click="
                          ViewCategoryProduct('Food, Beverages & Tobacco')
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="800px"
                          height="800px"
                          viewBox="0 0 1024 1024"
                          fill="#000000"
                          class="icon"
                          version="1.1"
                        >
                          <path
                            d="M961.094 190.992c-17.138 0-40.368-4.882-63.738-13.388-35.882-13.05-63.626-31.266-70.672-46.412-2.812-6.044-2.124-10.818-1.062-13.754 3.218-8.858 13.262-13.35 29.838-13.35 17.152 0 40.38 4.882 63.768 13.404 20.778 7.552 39.524 17.152 52.786 27.034 16.184 12.05 22.558 23.19 18.95 33.094-3.22 8.872-13.28 13.372-29.87 13.372z m-105.636-70.908c-10.436 0-14.31 2.18-14.874 2.938-0.282 4.376 18.262 23.558 62.238 39.554 21.682 7.888 42.928 12.42 58.27 12.42 10.45 0 14.34-2.188 14.886-2.954 0.296-4.368-18.262-23.536-62.222-39.524-21.712-7.902-42.958-12.434-58.298-12.434zM911.26 287.692a9.4 9.4 0 0 1-1.032-0.062c-14.764-1.906-31.51-6.164-48.444-12.326-16.856-6.116-32.414-13.592-44.944-21.622-3.718-2.382-4.782-7.326-2.406-11.052 2.376-3.732 7.294-4.81 11.06-2.412 11.53 7.396 25.962 14.332 41.742 20.048 15.856 5.774 31.43 9.74 45.022 11.49a8.008 8.008 0 0 1 6.92 8.958 7.99 7.99 0 0 1-7.918 6.978z"
                            fill=""
                          />
                          <path
                            d="M731.282 408.026c-0.906 0-1.828-0.156-2.734-0.484a7.988 7.988 0 0 1-4.78-10.248l101.854-279.848a8 8 0 0 1 10.248-4.782 7.99 7.99 0 0 1 4.78 10.248L738.794 402.76a8 8 0 0 1-7.512 5.266zM901.512 408.042c-0.906 0-1.844-0.156-2.734-0.484a7.99 7.99 0 0 1-4.782-10.248l81.938-225.156c1.5-4.156 6.108-6.28 10.248-4.782a7.99 7.99 0 0 1 4.78 10.248l-81.936 225.156a7.988 7.988 0 0 1-7.514 5.266zM766.29 405.728a7.99 7.99 0 0 1-7.514-10.732l54.864-150.782a8.02 8.02 0 0 1 10.248-4.78 7.988 7.988 0 0 1 4.782 10.248l-54.866 150.782a7.99 7.99 0 0 1-7.514 5.264zM867.442 408.042c-0.906 0-1.828-0.156-2.734-0.484a7.988 7.988 0 0 1-4.782-10.248l43.804-120.35c1.5-4.148 6.108-6.274 10.246-4.782a7.99 7.99 0 0 1 4.782 10.248l-43.802 120.35a8.006 8.006 0 0 1-7.514 5.266zM951.906 488.008H8.104c-4.422 0-8-3.576-8-7.998V432.02a7.994 7.994 0 0 1 8-7.998h415.914c4.42 0 8 3.578 8 7.998a7.994 7.994 0 0 1-8 7.998H16.102v31.994h927.806v-31.994H535.992a7.992 7.992 0 0 1-7.996-7.998 7.992 7.992 0 0 1 7.996-7.998h415.914c4.422 0 8 3.578 8 7.998v47.99a7.994 7.994 0 0 1-8 7.998z"
                            fill=""
                          />
                          <path
                            d="M823.934 951.912H136.078a7.992 7.992 0 0 1-7.834-6.374l-95.98-463.912a8.008 8.008 0 0 1 6.218-9.452c4.272-0.922 8.552 1.882 9.452 6.216l94.66 457.524H817.42l94.652-457.524c0.904-4.334 5.124-7.138 9.466-6.216a8.03 8.03 0 0 1 6.216 9.452l-95.98 463.912a8.004 8.004 0 0 1-7.84 6.374z"
                            fill=""
                          />
                          <path
                            d="M823.934 951.912a7.972 7.972 0 0 1-6.654-3.56 7.988 7.988 0 0 1 2.216-11.092l45.274-30.166 90.886-436.434c0.89-4.318 5.032-7.17 9.466-6.194a7.99 7.99 0 0 1 6.186 9.458L879.75 913.56a7.942 7.942 0 0 1-3.39 5.016l-47.988 31.992a8.03 8.03 0 0 1-4.438 1.344zM480.006 855.934c-17.644 0-31.994-14.342-31.994-31.994V599.984c0-17.636 14.348-31.992 31.994-31.992S512 582.348 512 599.984V823.94c0 17.652-14.348 31.994-31.994 31.994z m0-271.946c-8.818 0-15.998 7.188-15.998 15.996V823.94c0 8.826 7.178 15.996 15.998 15.996s15.998-7.17 15.998-15.996V599.984c-0.002-8.808-7.18-15.996-15.998-15.996zM304.042 855.934c-17.644 0-31.994-14.342-31.994-31.994l-15.974-223.376c-0.024-18.214 14.326-32.57 31.97-32.57s31.994 14.356 31.994 31.992l15.974 223.392c0.024 18.214-14.326 32.556-31.97 32.556z m-15.996-271.946c-8.818 0-15.998 7.188-15.998 15.996l15.974 223.392c0.024 9.388 7.202 16.558 16.02 16.558s15.998-7.17 15.998-15.996l-15.974-223.376c-0.024-9.386-7.202-16.574-16.02-16.574zM655.968 855.934c-17.652 0-31.994-14.342-31.994-31.994l16.03-224.518c-0.032-17.074 14.308-31.43 31.96-31.43s31.994 14.356 31.994 31.992l-16.03 224.534c0.032 17.074-14.306 31.416-31.96 31.416z m15.996-271.946c-8.81 0-15.996 7.188-15.996 15.996l-16.028 224.534c0.032 8.248 7.216 15.418 16.028 15.418s15.996-7.17 15.996-15.996l16.028-224.518c-0.032-8.246-7.216-15.434-16.028-15.434zM8.112 440.018a7.994 7.994 0 0 1-4.446-14.652l47.99-31.994a7.988 7.988 0 0 1 11.092 2.218 7.994 7.994 0 0 1-2.218 11.092L12.54 438.676a8.012 8.012 0 0 1-4.428 1.342zM951.906 440.018a7.97 7.97 0 0 1-6.654-3.56 7.988 7.988 0 0 1 2.218-11.092l47.99-31.994a7.99 7.99 0 0 1 11.092 2.218 7.99 7.99 0 0 1-2.218 11.092l-47.99 31.994a8.04 8.04 0 0 1-4.438 1.342z"
                            fill=""
                          />
                          <path
                            d="M951.906 488.008a7.976 7.976 0 0 1-6.654-3.56 7.988 7.988 0 0 1 2.218-11.092l47.99-31.994a8 8 0 0 1 8.874 13.31l-47.99 31.992a8.024 8.024 0 0 1-4.438 1.344zM999.896 408.026h-15.996a7.994 7.994 0 0 1-7.998-7.998 7.994 7.994 0 0 1 7.998-7.998h15.996a7.992 7.992 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998zM72.09 408.026h-15.998a7.994 7.994 0 0 1-7.998-7.998 7.994 7.994 0 0 1 7.998-7.998h15.998a7.994 7.994 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998z"
                            fill=""
                          />
                          <path
                            d="M999.896 456.016a7.994 7.994 0 0 1-7.998-7.998v-47.99a7.994 7.994 0 0 1 7.998-7.998 7.992 7.992 0 0 1 7.998 7.998v47.99a7.994 7.994 0 0 1-7.998 7.998zM504 464.014a7.994 7.994 0 0 1-7.998-7.998V120.084h-31.994v335.932c0 4.42-3.578 7.998-7.998 7.998s-7.998-3.578-7.998-7.998V112.086a7.994 7.994 0 0 1 7.998-7.998H504a7.994 7.994 0 0 1 7.998 7.998v343.93a7.992 7.992 0 0 1-7.998 7.998zM551.99 376.032a7.992 7.992 0 0 1-7.998-7.998V80.094c0-4.422 3.576-8 7.998-8a7.994 7.994 0 0 1 7.998 8v287.94a7.994 7.994 0 0 1-7.998 7.998z"
                            fill=""
                          />
                          <path
                            d="M504.008 120.084a7.98 7.98 0 0 1-6.662-3.56 7.992 7.992 0 0 1 2.218-11.092l47.988-31.994c3.688-2.458 8.638-1.46 11.092 2.218s1.468 8.638-2.218 11.092l-47.988 31.994a8.008 8.008 0 0 1-4.43 1.342zM456.018 120.084a7.98 7.98 0 0 1-6.662-3.56 7.992 7.992 0 0 1 2.218-11.092l47.99-31.994a7.988 7.988 0 0 1 11.09 2.218 7.992 7.992 0 0 1-2.218 11.092l-47.99 31.994a7.998 7.998 0 0 1-4.428 1.342zM567.986 408.026h-31.994a7.992 7.992 0 0 1-7.996-7.998 7.992 7.992 0 0 1 7.996-7.998h31.994a7.992 7.992 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998zM951.906 408.026a8.02 8.02 0 0 1-4.436-1.344 7.986 7.986 0 0 1-2.218-11.092l63.986-95.98c2.438-3.686 7.39-4.67 11.092-2.216a7.98 7.98 0 0 1 2.218 11.09l-63.986 95.98a7.972 7.972 0 0 1-6.656 3.562z"
                            fill=""
                          />
                          <path
                            d="M1015.894 312.044h-47.99a7.994 7.994 0 0 1-7.998-7.998 7.992 7.992 0 0 1 7.998-7.998h47.99a7.994 7.994 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998zM328.038 408.042c-4.422 0-8-3.578-8-7.998v-87.998H176.07v87.998a7.994 7.994 0 0 1-7.998 7.998c-4.422 0-8-3.578-8-7.998v-95.996a7.994 7.994 0 0 1 8-7.998h159.966a7.994 7.994 0 0 1 7.998 7.998v95.996a7.996 7.996 0 0 1-7.998 7.998zM424.018 408.026h-63.988a7.994 7.994 0 0 1-7.998-7.998 7.994 7.994 0 0 1 7.998-7.998h63.988a7.998 7.998 0 1 1 0 15.996z"
                            fill=""
                          />
                          <path
                            d="M328.046 312.044a7.99 7.99 0 0 1-6.664-3.562l-31.994-47.99a7.99 7.99 0 0 1 2.218-11.09 7.994 7.994 0 0 1 11.09 2.216l31.994 47.99a7.992 7.992 0 0 1-6.644 12.436z"
                            fill=""
                          />
                          <path
                            d="M296.044 264.054H136.078a7.994 7.994 0 0 1-7.998-7.998 7.994 7.994 0 0 1 7.998-7.998h159.966a7.994 7.994 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998z"
                            fill=""
                          />
                          <path
                            d="M168.08 312.044a7.99 7.99 0 0 1-6.664-3.562l-31.992-47.99a7.99 7.99 0 0 1 2.218-11.09 7.99 7.99 0 0 1 11.09 2.216l31.994 47.99a7.992 7.992 0 0 1-6.646 12.436z"
                            fill=""
                          />
                          <path
                            d="M104.076 312.044a7.992 7.992 0 0 1-6.646-12.436l31.994-47.99a7.984 7.984 0 0 1 11.09-2.216 7.992 7.992 0 0 1 2.218 11.09L110.74 308.482a7.99 7.99 0 0 1-6.664 3.562z"
                            fill=""
                          />
                          <path
                            d="M104.084 408.026c-4.42 0-8-3.578-8-7.998v-95.98c0-4.422 3.578-7.998 8-7.998s7.998 3.576 7.998 7.998v95.98a7.994 7.994 0 0 1-7.998 7.998zM136.078 408.026a7.994 7.994 0 0 1-7.998-7.998v-79.984c0-4.42 3.578-7.998 7.998-7.998s7.998 3.578 7.998 7.998v79.984a7.994 7.994 0 0 1-7.998 7.998zM296.044 264.054H136.078a7.994 7.994 0 0 1-7.998-7.998v-31.994a7.994 7.994 0 0 1 7.998-7.998h159.966a7.994 7.994 0 0 1 7.998 7.998v31.994a7.994 7.994 0 0 1-7.998 7.998z m-151.968-15.996h143.97v-15.998H144.076v15.998zM551.99 88.092H504a7.994 7.994 0 0 1-7.998-7.998c0-4.422 3.578-8 7.998-8h47.99a7.994 7.994 0 0 1 7.998 8 7.994 7.994 0 0 1-7.998 7.998zM695.96 408.026c-4.422 0-8-3.578-8-7.998 0-22.05-17.934-39.992-39.99-39.992-22.058 0-39.992 17.942-39.992 39.992a7.994 7.994 0 0 1-7.998 7.998 7.994 7.994 0 0 1-7.998-7.998c0-30.87 25.12-55.988 55.988-55.988s55.988 25.12 55.988 55.988a7.994 7.994 0 0 1-7.998 7.998zM663.966 328.042h-31.994a7.994 7.994 0 0 1-7.998-7.998 7.994 7.994 0 0 1 7.998-7.998h31.994a7.994 7.994 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998z"
                            fill=""
                          />
                          <path
                            d="M631.972 344.04a7.994 7.994 0 0 1-7.998-8v-15.996a7.994 7.994 0 0 1 7.998-7.998c4.422 0 8 3.578 8 7.998v15.996c0 4.42-3.578 8-8 8z"
                            fill=""
                          />
                          <path
                            d="M663.966 344.04a7.994 7.994 0 0 1-7.998-8v-15.996c0-4.42 3.578-7.998 7.998-7.998s7.998 3.578 7.998 7.998v15.996c0 4.42-3.578 8-7.998 8z"
                            fill=""
                          />
                          <path
                            d="M695.96 312.044c-0.5 0-1.032-0.046-1.562-0.156l-79.984-15.996a7.988 7.988 0 0 1-6.28-9.412c0.876-4.336 5.06-7.204 9.404-6.274l79.984 15.998a7.988 7.988 0 0 1 6.28 9.412 7.986 7.986 0 0 1-7.842 6.428z"
                            fill=""
                          />
                          <path
                            d="M615.976 328.042a7.992 7.992 0 0 1-7.998-7.998v-31.992c0-4.422 3.576-8 7.998-8s7.998 3.578 7.998 8v31.992a7.994 7.994 0 0 1-7.998 7.998z"
                            fill=""
                          />
                          <path
                            d="M695.96 328.042h-79.984a7.992 7.992 0 0 1-7.998-7.998 7.994 7.994 0 0 1 7.998-7.998h79.984a7.994 7.994 0 0 1 7.998 7.998 7.994 7.994 0 0 1-7.998 7.998z"
                            fill=""
                          />
                          <path
                            d="M695.96 328.042c-4.422 0-8-3.576-8-7.998v-15.996a7.994 7.994 0 0 1 8-7.998 7.994 7.994 0 0 1 7.998 7.998v15.996a7.994 7.994 0 0 1-7.998 7.998z"
                            fill=""
                          />
                          <path
                            d="M283.82 408.01a7.966 7.966 0 0 1-5.958-2.664c-15.138-16.902-44.388-16.942-59.59-0.008a7.98 7.98 0 0 1-11.294 0.61 7.996 7.996 0 0 1-0.61-11.294 56.08 56.08 0 0 1 41.686-18.622 56.082 56.082 0 0 1 41.726 18.644 8.004 8.004 0 0 1-5.96 13.334z"
                            fill=""
                          />
                          <path
                            d="M504 464.014h-47.99a7.994 7.994 0 0 1-7.998-7.998 7.994 7.994 0 0 1 7.998-7.998H504a7.994 7.994 0 0 1 7.998 7.998 7.992 7.992 0 0 1-7.998 7.998z"
                            fill=""
                          />
                        </svg>
                        <span class="cat-name">Food, Bevs & Tobacco</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Furniture')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          width="800px"
                          height="800px"
                          viewBox="0 0 512 512"
                          enable-background="new 0 0 512 512"
                          id="couch_1_"
                          version="1.1"
                          xml:space="preserve"
                        >
                          <path
                            d="M448.277,189.944h-1.727v-48.459c0-19.586-15.939-35.521-35.533-35.521H101.283  c-19.586,0-35.52,15.935-35.52,35.521v50.939h-2.039c-19.125,0-34.686,15.56-34.686,34.686v65.22h0.323v74.242  c0,8.568,6.972,15.539,15.541,15.539h10.894v14.557c0,5.165,4.202,9.367,9.366,9.367h8.4c5.164,0,9.365-4.202,9.365-9.367v-14.557  h346.457v14.557c0,5.165,4.201,9.367,9.365,9.367h8.4c5.164,0,9.367-4.202,9.367-9.367v-14.557h10.906  c8.568,0,15.537-6.971,15.537-15.539v-74.161v-7.28V224.63C482.961,205.504,467.402,189.944,448.277,189.944z M72.963,141.485  c0-15.616,12.704-28.32,28.319-28.32h309.735c15.623,0,28.334,12.704,28.334,28.32v48.459h-5.684  c-9.695,0-17.584,7.889-17.584,17.586v28.513c-33.221-21.594-69.889-35.985-109.111-42.784  c-33.758-5.854-67.955-5.787-101.646,0.194c-40.06,7.097-77.369,22.082-111.014,44.547v-27.99c0-9.696-7.889-17.585-17.585-17.585  h-3.765V141.485z M416.084,244.683v40.444H309.963v-83.985C348.17,208.345,383.842,222.975,416.084,244.683z M205.056,200.834  c0.511-0.093,1.016-0.201,1.527-0.291c32.865-5.837,66.229-5.901,99.159-0.189c0.863,0.149,1.715,0.324,2.574,0.48h-5.553v84.293  h-93.209v-84.293H205.056z M202.354,201.351v83.776H94.313v-38.414C126.981,224.104,163.299,208.862,202.354,201.351z   M36.239,227.11c0-15.155,12.329-27.485,27.485-27.485h13.004c5.728,0,10.386,4.659,10.386,10.385v75.121H36.239V227.11z   M75.728,396.668c0,1.195-0.971,2.166-2.165,2.166h-8.4c-1.195,0-2.166-0.971-2.166-2.166v-13.913h12.731V396.668z M449.318,396.668  c0,1.195-0.973,2.166-2.168,2.166h-8.4c-1.195,0-2.166-0.971-2.166-2.166v-13.913h12.734V396.668z M475.762,366.572  c0,4.599-3.74,8.34-8.338,8.34H44.903c-4.599,0-8.341-3.741-8.341-8.34V292.33h57.751h7.087h309.526h5.158v0.081h59.678V366.572z   M475.762,285.131h-52.479V207.53c0-5.727,4.658-10.386,10.385-10.386h14.609c15.156,0,27.484,12.33,27.484,27.485V285.131z"
                            id="couch"
                          />
                        </svg>
                        <span class="cat-name">Furniture</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Hardware')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512 512"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M212.195,239.946v63.615h159.593v-63.615H212.195z M356.162,287.936H227.821v-32.364h128.342V287.936z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <polygon
                                points="211.727,127.609 211.727,231.78 227.353,231.78 227.353,143.235 356.525,143.235 356.525,231.78 372.151,231.78     372.151,127.609   "
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="235.687"
                                y="183.862"
                                width="15.626"
                                height="47.919"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="284.647"
                                y="183.862"
                                width="15.626"
                                height="47.919"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="260.688"
                                y="207.821"
                                width="15.626"
                                height="23.959"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="332.566"
                                y="183.862"
                                width="15.626"
                                height="47.919"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="308.606"
                                y="207.821"
                                width="15.626"
                                height="23.959"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M356.525,311.992v16.384c-32.11,3.726-56.252,30.213-56.252,63.352v95.979c0,4.513-3.739,8.183-8.334,8.183    s-8.334-3.671-8.334-8.183v-95.979c0-32.547-24.597-59.481-56.252-63.329v-16.407h-15.626v31.251h7.813    c26.709,0,48.44,21.921,48.44,48.484v95.979c0,13.129,10.747,23.808,23.959,23.808s23.959-10.681,23.959-23.808v-95.979    c0-13.021,4.886-25.283,13.757-34.248c8.986-9.081,21.303-14.236,34.683-14.236h7.813v-31.251H356.525z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="244.02"
                                y="264.073"
                                width="15.626"
                                height="15.626"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="324.232"
                                y="264.073"
                                width="15.626"
                                height="15.626"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="283.605"
                                y="264.073"
                                width="16.667"
                                height="15.626"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M404.153,271.939v39.62h95.607v-39.62H404.153z M484.134,295.934h-64.356v-8.369h64.356V295.934z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <polygon
                                points="459.654,248.448 459.654,47.398 444.028,47.398 444.028,248.448 420.069,248.448 420.069,264.073     483.613,264.073 483.613,248.448   "
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="444.028"
                                y="416.163"
                                width="15.626"
                                height="15.626"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M483.613,340.555v-21.271h-15.626v27.637l15.626,15.997v84.497h-63.544v-84.497l15.626-15.997v-27.637h-15.626v21.271    l-15.626,15.996v107.16c0,26.359,21.262,47.804,47.398,47.804s47.398-21.445,47.398-47.804v-107.16L483.613,340.555z     M483.613,463.711c0,17.743-14.254,32.178-31.772,32.178s-31.772-14.435-31.772-32.178v-0.671h63.544V463.711z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M204.197,0v16.146h-16.367V0H60.044C33.685,0,12.24,21.445,12.24,47.804v31.993h15.626c0-13.333,10.847-24.18,24.18-24.18    h32.586c8.595,0,15.589,6.993,15.589,15.589v40.399h87.61V71.357h16.367V87.61h87.609V0H204.197z M172.205,95.979L172.205,95.979    h-56.36V71.205c0-17.211-14.003-31.215-31.215-31.215H52.046c-9.087,0-17.473,3.061-24.18,8.206v-0.392    c0-17.743,14.435-32.178,32.178-32.178h112.161V95.979z M204.197,55.731h-16.367V31.772h16.367V55.731z M276.181,71.984h-56.359    V15.626h0h56.359V71.984z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M107.556,120.317v15.626h8.334V512h56.252V135.943h8.334v-15.626H107.556z M156.517,496.374h-25.001v-5.107l25.001-25.001    V496.374z M156.517,444.169l-25.001,25.001v-25.892l25.001-25.001V444.169z M156.517,396.18l-25.001,25.001v-25.892l25.001-25.001    V396.18z M156.517,348.191l-25.001,25.001v-37.241h25.001V348.191z M156.517,320.326h-25.001V135.943h25.001V320.326z"
                              />
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Hardware</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct(' Health & Beauty ')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 503.607 503.607"
                          xml:space="preserve"
                        >
                          <g transform="translate(1 1)">
                            <g>
                              <g>
                                <path
                                  d="M494.213,150.082c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393h-41.967v-8.393h41.967     c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393h-41.967v-8.393h33.574c5.036,0,8.393-3.357,8.393-8.393     s-3.357-8.393-8.393-8.393h-33.574v-8.393h25.18c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393h-25.18v-8.393h16.787     c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393h-16.787V24.18h8.393c5.036,0,8.393-3.357,8.393-8.393     s-3.357-8.393-8.393-8.393h-8.393c0-5.036-3.357-8.393-8.393-8.393c-5.036,0-8.393,3.357-8.393,8.393h-8.393     c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h8.393v8.393h-16.787c-5.036,0-8.393,3.357-8.393,8.393     c0,5.036,3.357,8.393,8.393,8.393h16.787v8.393h-25.18c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h25.18v8.393     h-33.574c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h33.574v8.393h-41.967c-5.036,0-8.393,3.357-8.393,8.393     s3.357,8.393,8.393,8.393h41.967v8.393h-41.967c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h41.967v8.393h-41.967     c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h41.967v8.393h-41.967c-5.036,0-8.393,3.357-8.393,8.393     s3.357,8.393,8.393,8.393h41.967v8.393h-33.574c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h33.574v8.393h-25.18     c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h25.18v8.393h-16.787c-5.036,0-8.393,3.357-8.393,8.393     c0,5.036,3.357,8.393,8.393,8.393h16.787v33.574h-10.072c-12.59,0-23.502,10.911-23.502,23.502v18.466h-16.787v151.082h117.508     V351.525H485.82v-18.466c0-12.59-10.911-23.502-23.502-23.502h-10.072v-33.574h16.787c5.036,0,8.393-3.357,8.393-8.393     c0-5.036-3.357-8.393-8.393-8.393h-16.787v-8.393h25.18c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393h-25.18v-8.393     h33.574c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393h-33.574v-8.393h41.967c5.036,0,8.393-3.357,8.393-8.393     s-3.357-8.393-8.393-8.393h-41.967v-8.393h41.967c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393h-41.967v-8.393     H494.213z M485.82,485.82h-83.934V368.311h83.934V485.82z M469.033,333.059v18.466h-50.361v-18.466     c0-3.357,3.357-6.715,6.715-6.715h36.931C465.675,326.344,469.033,329.702,469.033,333.059z"
                                />
                                <path
                                  d="M317.951,129.181c1.429-8.7-0.389-16.419-5.875-21.906c-6.715-6.715-16.787-8.393-28.538-4.197     c-10.072,3.357-20.144,10.072-29.377,19.305c-9.233,9.233-15.948,19.305-19.305,29.377c-2.148,7.518-2.567,14.344-0.839,20.048     v104.175h-16.787v41.967v16.787v167.869h117.508V334.738v-16.787v-41.967h-16.787V129.181z M250.803,156.797     c2.518-7.554,7.554-16.787,15.108-23.502c7.554-6.715,15.948-12.59,23.502-15.108c3.357-1.679,5.875-1.679,7.554-1.679     s3.357,0.839,4.197,2.518c0.854,0.854,1.271,2.526,1.173,4.788c-0.559,0.814-0.967,1.739-1.173,2.766     c-1.679,8.393-7.554,17.626-15.948,26.02c-15.108,15.108-31.056,18.466-34.413,15.108c0,0,0,0-0.839-0.839     c-0.142-0.708-0.386-1.364-0.703-1.969C249.081,162.976,249.466,160.364,250.803,156.797z M250.803,185.915     c1.325,0.172,2.718,0.259,4.197,0.259c4.197,0,8.393-0.839,12.59-1.679c10.072-3.357,20.144-10.072,29.377-19.305     c1.472-1.472,2.867-2.963,4.197-4.463v115.256h-50.361V185.915z M317.951,485.82h-83.934V334.738h83.934V485.82z      M234.016,317.951v-25.18h8.393h67.148h8.393v25.18H234.016z"
                                />
                                <path
                                  d="M158.475,24.18c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393H66.148c-1.485,0-2.819,0.299-3.969,0.839     H39.289C17.466,8.233-1,25.859-1,48.521v397.01c0,21.823,17.626,40.289,40.289,40.289h26.859h8.393h83.934     c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393H74.541v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393     s-3.357-8.393-8.393-8.393H74.541v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393H74.541v-25.18h83.934     c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393H74.541v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393     c0-5.036-3.357-8.393-8.393-8.393H74.541v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393H74.541     v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393H74.541v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393     s-3.357-8.393-8.393-8.393H74.541v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393H74.541v-25.18h83.934     c5.036,0,8.393-3.357,8.393-8.393s-3.357-8.393-8.393-8.393H74.541v-25.18h83.934c5.036,0,8.393-3.357,8.393-8.393     s-3.357-8.393-8.393-8.393H74.541V24.18H158.475z M15.787,445.531V48.521c0-13.43,10.911-24.341,23.502-24.341h18.466v444.852     H39.289C26.698,469.033,15.787,458.961,15.787,445.531z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Health & Beauty</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Home & Garden')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512.001 512.001"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M482.509,122.333l-28.474-25.31c6.255-2.52,12.002-6.275,16.823-11.096c19.63-19.631,19.63-51.572,0-71.204    c-19.632-19.631-51.572-19.632-71.206,0c-6.272,6.272-10.706,14.002-12.985,22.417l-12.089-10.745    c-3.145-2.796-7.927-2.656-10.903,0.32l-83.946,83.946c-2.976,2.976-3.116,7.757-0.32,10.903l29.321,32.987l-78.297-3.729    c-7.168-13.55-21.654-22.444-37.082-22.444c-4.391,0-7.95,3.559-7.95,7.95v67.839c0,4.39,3.558,7.95,7.95,7.95    c10.753,0,21.337-4.269,29.039-11.711c2.714-2.621,5.016-5.563,6.888-8.724l128.817,18.402l17.252,19.409    c2.995,3.37,8.375,3.528,11.563,0.339l95.939-95.939C486.038,130.707,485.877,125.328,482.509,122.333z M211.341,188.973    c-2.831,2.737-6.296,4.779-10.04,5.986v-49.354c7.016,2.363,13.078,7.696,15.983,14.545    C221.374,169.787,218.931,181.639,211.341,188.973z M400.845,48.654c0.413-8.563,3.982-16.619,10.05-22.688    c13.429-13.432,35.286-13.433,48.719,0c13.432,13.432,13.432,35.288,0.001,48.718c-5.405,5.404-12.201,8.765-19.717,9.773    L400.728,49.64C400.785,49.318,400.829,48.99,400.845,48.654z M296.272,116.604l73.346-73.345l26.189,23.279l-76.256,76.255    L296.272,116.604z M234.708,176.398c0.47-3.114,0.593-6.28,0.356-9.436l88.44,4.211l0.675,0.759l17.561,19.756L234.708,176.398z     M381.63,212.631l-28.923-32.537l43.302-43.302c3.105-3.105,3.105-8.139,0-11.242c-3.106-3.105-8.139-3.105-11.243,0    l-42.641,42.641l-11.993-13.491l77.578-77.578l13.491,11.993l-11.88,11.88c-3.105,3.105-3.105,8.139,0,11.242    c3.106,3.105,8.138,3.105,11.243,0l12.542-12.543l32.538,28.923L381.63,212.631z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M165.605,228.532c-3.093-3.12-8.127-3.138-11.243-0.046c-6.3,6.253-12.153,13.05-17.391,20.203    c-2.33,3.181-1.927,7.726,0.925,10.448c3.425,3.268,9.108,2.76,11.903-1.053c4.748-6.483,10.051-12.643,15.764-18.311    C168.678,236.682,168.698,231.647,165.605,228.532z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M125.822,224.049c-3.468-2.691-8.464-2.064-11.155,1.406c-5.4,6.957-10.385,14.335-14.817,21.931    c-2.043,3.501-1.057,8.111,2.238,10.47c3.758,2.69,9.167,1.53,11.494-2.455c4.083-6.996,8.675-13.791,13.646-20.198    C129.92,231.735,129.29,226.741,125.822,224.049z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M163.346,189.863c-2.652-3.498-7.637-4.186-11.137-1.532c-7.01,5.315-13.734,11.145-19.987,17.328    c-3.122,3.088-3.15,8.122-0.064,11.242c1.555,1.572,3.603,2.361,5.653,2.361c2.019,0,4.041-0.765,5.589-2.297    c5.761-5.697,11.955-11.067,18.414-15.964C165.314,198.349,165.998,193.362,163.346,189.863z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M83.078,221.001c-3.728-2.318-8.63-1.175-10.948,2.553c-4.619,7.43-8.87,15.196-12.631,23.081    c-1.89,3.962-0.21,8.708,3.753,10.598c3.913,1.867,8.733,0.156,10.598-3.753c3.509-7.354,7.472-14.598,11.782-21.529    C87.951,228.222,86.806,223.321,83.078,221.001z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M115.87,182.202c-3.129-3.079-8.163-3.042-11.242,0.088c-6.137,6.234-11.987,12.872-17.388,19.73    c-2.719,3.45-2.124,8.448,1.325,11.165c3.405,2.682,8.485,2.075,11.164-1.326c5.041-6.4,10.501-12.596,16.229-18.415    C119.038,190.315,118.998,185.282,115.87,182.202z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M156.359,151.542c-2.376-3.691-7.296-4.755-10.988-2.38c-7.342,4.729-14.505,9.921-21.285,15.436    c-2.474,2.011-3.516,5.404-2.599,8.458c0.997,3.323,4.149,5.659,7.619,5.659c1.762,0,3.536-0.583,5.01-1.782    c6.329-5.145,13.011-9.992,19.863-14.404C157.67,160.152,158.735,155.233,156.359,151.542z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M175.186,314.386c-0.939-2.206-2.821-3.872-5.125-4.534c-2.302-0.662-4.783-0.25-6.748,1.122    c-6.837,4.776-41.202,29.49-46.251,47.061c-2.776,9.661-1.625,19.824,3.244,28.617c2.188,3.953,5.014,7.411,8.335,10.279    c-6.628,6.307-15.354,12.24-26.847,16.987c-2.657-8.688-5.681-16.827-8.664-24.846c-3.154-8.48-6.148-16.535-8.513-24.717    c4.883-1.613,9.423-4.237,13.36-7.78c7.47-6.726,11.873-15.958,12.399-25.995c0.957-18.258-23.469-52.827-28.375-59.573    c-2.923-4.019-9.003-4.339-12.334-0.647c-5.585,6.195-33.491,38.021-34.447,56.28c-1.047,19.957,13.736,37.144,33.342,39.354    c2.655,9.767,6.12,19.089,9.666,28.622c5.778,15.533,11.725,31.532,14.457,50.975c-31.44,3.058-58.015,25.413-66.01,56.475    c-1.094,4.253,1.466,8.587,5.719,9.681c4.257,1.098,8.587-1.466,9.681-5.718c6.805-26.442,30.657-44.91,58.002-44.91    s51.197,18.468,58.002,44.91c1.111,4.317,5.706,6.896,9.974,5.636c4.043-1.194,6.472-5.526,5.424-9.599    c-7.887-30.643-33.857-52.812-64.741-56.341c-0.721-5.722-1.682-11.141-2.832-16.315c16.904-6.649,28.909-15.562,37.433-24.692    c15.377,4.2,32.212-2.011,41.113-15.247c2.194-3.263,3.862-6.871,4.947-10.648C194.446,361.25,178.446,322.063,175.186,314.386z     M80.417,318.132c0.514-4.361-2.604-8.311-6.964-8.825c-4.371-0.515-8.312,2.604-8.825,6.965    c-1.411,11.974-1.089,22.652,0.336,32.596c-8.517-3.303-14.37-11.788-13.867-21.395c0.407-7.757,12.612-25.27,23.797-38.815    c9.705,14.633,20.011,33.321,19.604,41.091c-0.438,8.335-5.747,15.789-13.468,18.957    C79.505,339.325,79.092,329.377,80.417,318.132z M174.111,374.43c-1.604,5.579-5.283,10.199-10.36,13.009    c-2.959,1.639-6.189,2.525-9.473,2.682c1.6-2.707,2.943-5.332,4.064-7.811c7.597-16.8,7.089-30.853,7.064-31.443    c-0.189-4.387-3.88-7.776-8.284-7.601c-4.386,0.189-7.79,3.898-7.601,8.284c0.012,0.266,0.466,16.228-10.653,33.169    c-1.842-1.626-3.428-3.553-4.653-5.767c-2.81-5.078-3.476-10.946-1.873-16.525c2.144-7.464,17.985-21.773,31.934-32.447    C170.431,346.431,176.257,366.966,174.111,374.43z"
                              />
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Home & Garden</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct(' Luggage & Bags ')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512 512"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M379.458,107.009h-41.252V52.681h4.41c14.524,0,26.34-11.816,26.34-26.34C368.955,11.816,357.139,0,342.615,0h-132.85     c-14.524,0-26.34,11.816-26.34,26.34s11.816,26.34,26.34,26.34h4.41v54.329h-41.252c-19.297,0-34.996,15.7-34.996,34.996v104.976     c-11.706-1.439-26.192,5.442-32.799,12.049c-10.11,10.11-10.11,26.562,0,36.672c4.898,4.897,11.41,7.596,18.337,7.596     c5.23,0,10.222-1.539,14.462-4.401v140.017c0,19.297,15.7,34.996,34.996,34.996h6.157v19.19c0,10.421,8.478,18.9,18.9,18.9     h21.595c10.421,0,18.9-8.478,18.9-18.9v-19.19h75.432v19.19c0,10.421,8.478,18.9,18.9,18.9h21.595c10.421,0,18.9-8.478,18.9-18.9     v-19.19h6.163c19.297,0,34.996-15.7,34.996-34.996V142.006C414.453,122.709,398.754,107.009,379.458,107.009z M130.383,284.286     c-1.848,1.848-4.305,2.866-6.92,2.866c-2.615,0-5.072-1.018-6.92-2.866c-3.816-3.816-3.816-10.024,0-13.84     c4.809-4.809,14.012-7.589,18.5-7.589c1.15,0,1.991,0.182,2.368,0.561c0.271,0.271,0.439,0.786,0.513,1.478v1.947h0.001     C137.554,271.597,134.842,279.828,130.383,284.286z M209.764,36.536c-5.622,0-10.195-4.573-10.195-10.195     s4.573-10.195,10.195-10.195h132.85c5.622,0,10.195,4.573,10.195,10.195s-4.573,10.195-10.195,10.195H209.764z M322.061,52.681     v54.329h-10.48V52.681H322.061z M295.434,52.681v54.329h-38.489V52.681H295.434z M240.8,52.681v54.329h-10.48V52.681H240.8z      M172.922,457.765c-10.394,0-18.851-8.457-18.851-18.851v-4.839c11.633,2.944,20.867,12.089,23.924,23.69H172.922z      M219.571,495.855h-21.595c-1.519,0-2.754-1.236-2.754-2.754v-19.19h27.102v19.19h0.001     C222.325,494.619,221.091,495.855,219.571,495.855z M354.395,495.855H332.8c-1.519,0-2.754-1.236-2.754-2.754v-19.19h27.102     v19.19h0.001C357.15,494.619,355.915,495.855,354.395,495.855z M398.308,438.914c0,10.394-8.456,18.851-18.851,18.851h-5.074     c3.057-11.601,12.291-20.747,23.925-23.69V438.914z M398.309,417.603h-0.001c-20.528,3.423-36.867,19.652-40.424,40.163H194.494     c-3.556-20.511-19.894-36.74-40.423-40.163V142.006c0-10.394,8.457-18.851,18.851-18.851h206.536     c10.394,0,18.851,8.457,18.851,18.851V417.603z"
                                />
                                <path
                                  d="M338.557,287.153H213.822c-4.459,0-8.073,3.614-8.073,8.073c0,4.458,3.613,8.073,8.073,8.073h124.735     c4.459,0,8.073-3.614,8.073-8.073C346.629,290.768,343.015,287.153,338.557,287.153z"
                                />
                                <path
                                  d="M338.557,331.248H213.822c-4.459,0-8.073,3.614-8.073,8.073c0,4.458,3.613,8.073,8.073,8.073h124.735     c4.459,0,8.073-3.614,8.073-8.073S343.015,331.248,338.557,331.248z"
                                />
                                <path
                                  d="M338.557,375.344H213.822c-4.459,0-8.073,3.614-8.073,8.073c0,4.458,3.613,8.073,8.073,8.073h124.735     c4.459,0,8.073-3.614,8.073-8.073C346.629,378.958,343.015,375.344,338.557,375.344z"
                                />
                                <path
                                  d="M255.606,220.414h41.167c4.459,0,8.073-3.614,8.073-8.073c0-4.458-3.613-8.073-8.073-8.073h-41.167     c-4.459,0-8.073,3.614-8.073,8.073C247.533,216.8,251.148,220.414,255.606,220.414z"
                                />
                                <path
                                  d="M276.189,251.33c34.776,0,62.016-17.126,62.016-38.99c0-21.863-27.241-38.989-62.016-38.989     s-62.015,17.126-62.015,38.988C214.174,234.205,241.414,251.33,276.189,251.33z M276.189,189.498     c27.032,0,45.871,12.039,45.871,22.843c0,10.805-18.838,22.844-45.871,22.844c-27.031,0-45.87-12.039-45.87-22.844     C230.319,201.537,249.158,189.498,276.189,189.498z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Luggage & Bags</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Media')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="#000000"
                          width="800px"
                          height="800px"
                          viewBox="0 0 64 64"
                        >
                          <g id="a" />

                          <g id="b">
                            <path
                              d="M50,16.0146v-5.5253c0-.1943-.1123-.3706-.2881-.4531-.1748-.0811-.3848-.0552-.5322,.0693-6.8387,5.7183-17.4261,6.855-17.7166,6.885l-11.8411,.7893c-1.5962,.1064-3.1899,.3672-4.7363,.7749-1.1102,.2924-1.8854,1.2913-1.8857,2.4287h-.5001c-2.4814,0-4.5,2.3467-4.5,5.2314v3.5483c0,2.8848,2.0186,5.2314,4.5,5.2314h.5001c.0002,1.1374,.7755,2.1363,1.8857,2.4287,.9074,.2393,1.832,.4214,2.763,.558,.5023,.4549,2.34,2.2903,3.0822,5.4103,.6973,2.9302,.1816,5.8906-1.4517,8.3369-.2988,.4478-.3257,.999-.0713,1.4741,.2603,.4868,.7695,.7891,1.3291,.7891h8.9331c.4438,0,.8623-.1899,1.1479-.5215,.2764-.3208,.3994-.7437,.3374-1.1606-.3254-2.1784-1.2852-8.5849-3.4286-13.584l3.9362,.2625c.2903,.03,10.8778,1.1662,17.7166,6.885,.0908,.0767,.2051,.1162,.3203,.1162,.0723,0,.1445-.0156,.2119-.0469,.1758-.0825,.2881-.2588,.2881-.4531v-5.5253c3.3505-.257,6-3.0594,6-6.4747v-11c0-3.4152-2.6495-6.2177-6-6.4747ZM9,29.7632v-3.5483c0-2.333,1.5703-4.2314,3.5-4.2314h.5v12.0112h-.5c-1.9297,0-3.5-1.8984-3.5-4.2314Zm20.9663,22.6938c.0195,.1309-.0181,.2588-.106,.3604-.0952,.1108-.2378,.1743-.3901,.1743h-8.9331c-.1929,0-.3604-.0977-.4473-.2607-.0371-.0693-.1094-.2515,.0215-.4468,1.7891-2.6802,2.355-5.9204,1.5923-9.124-.5588-2.3491-1.6739-4.0107-2.5112-5.0009,.1433,.012,.2863,.0294,.4296,.039l6.7756,.4519c1.4865,3.2765,2.6885,7.9119,3.5687,13.8069Zm1.0337-14.5024l-11.3115-.7544c-1.5327-.1021-3.063-.3521-4.5479-.7437-.6714-.1772-1.1406-.7783-1.1406-1.4624v-14.0103c0-.6841,.4692-1.2852,1.1406-1.4624,1.4849-.3916,3.0151-.6416,4.5479-.7437l11.3115-.7539v19.9307Zm18,6.4971c-6.3689-4.8357-14.9624-6.1545-17-6.4078V17.9346c2.0376-.2532,10.6311-1.5725,17-6.4078V44.4517Zm6-10.9624c0,2.8639-2.2014,5.2208-5,5.4747V17.0146c2.7986,.2538,5,2.6108,5,5.4747v11Z"
                            />
                          </g>
                        </svg>
                        <span class="cat-name">Media</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct(' Office Supplies ')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 497.8 497.8"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <g>
                                <rect
                                  x="416.9"
                                  y="209.8"
                                  width="16"
                                  height="16"
                                />
                                <rect
                                  x="304.9"
                                  y="209.8"
                                  width="96"
                                  height="16"
                                />
                                <path
                                  d="M496.9,63.976c0-34.288-27.888-62.176-62.176-62.176h-31.368l-48,128H352.9V1.8h-112v128h-3.056L182.476,19.072     L115.732,0L96.26,58.416l35.696,71.384H128.9v64h16v148.192c-4.88-4.032-10.232-7.56-16-10.512V297.8v-8v-32h-16v32h-16v-32h-16     v32h-16v-32h-16v32v8v33.688c-29.312,14.976-48,45.136-48,78.312c0,48.52,39.48,88,88,88c25.184,0,47.872-10.696,63.928-27.712     c9.912,16.744,28.04,27.712,48.072,27.712h208c30.872,0,56-25.12,56-56v-248h16v-64h-4.456l16.496-43.992     C495.564,78.8,496.9,71.456,496.9,63.976z M256.9,17.8h80v16h-32v16h32v16h-32v16h32v16h-32v16h32v16h-80V17.8z M219.956,129.8     h-29.904l-35.2-77.448l21.592-9.6L219.956,129.8z M126.068,19.6l38.408,10.976L115.1,52.52L126.068,19.6z M119.076,68.256     l21.152-9.4l32.248,70.944h-22.632L119.076,68.256z M64.9,305.8h48v104c0,13.232-10.768,24-24,24s-24-10.768-24-24V305.8z      M88.9,481.8c-39.704,0-72-32.304-72-72c0-24.256,12.288-46.464,32-59.688V409.8c0,22.056,17.944,40,40,40     c22.056,0,40-17.944,40-40v-59.688c19.712,13.216,32,35.432,32,59.688C160.9,449.496,128.604,481.8,88.9,481.8z M448.9,441.8     c0,22.056-17.944,40-40,40h-208c-16.584,0-31.384-10.504-37.232-25.824c8.336-13.44,13.232-29.232,13.232-46.176     c0-18.456-5.824-35.96-16-50.464V193.8h288V441.8z M464.9,177.8h-320v-32h320V177.8z M477.956,80.192l-18.6,49.608h-46.912     l4.944-13.192l-14.984-5.616l-7.048,18.808h-22.912l42-112h20.272c0.872,0,1.728,0.08,2.584,0.128l-28.896,77.064l14.984,5.616     L453.02,21.6c16.384,7.104,27.88,23.416,27.88,42.376C480.9,69.528,479.908,74.984,477.956,80.192z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Office Supplies</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Religious & Ceremonial')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="_x32_"
                          viewBox="0 0 512 512"
                          xml:space="preserve"
                        >
                          <g>
                            <path
                              class="st000"
                              d="M390.305,235.134H237.759v-12.689l-93.676-107.348V72.594h35.682V33.46h-35.682V0h-39.142v33.46H69.26v39.134   h35.681v42.518L11.265,222.444V512h93.782v-88.388c0.03-10.748,8.732-19.45,19.473-19.465c10.741,0.015,19.442,8.717,19.457,19.465   V512h71.575h16.028h6.178h149.737h113.239V361.667L390.305,235.134z M225.387,287.939v211.682h-9.835h-59.203v-76.009   c0-17.584-14.246-31.837-31.829-31.837c-17.584,0-31.845,14.253-31.845,31.837v76.009H23.637V227.09l93.676-107.34V60.214H81.632   V45.833l35.681,0.008V12.372h14.397V45.84h35.682v14.374h-35.682v59.528l93.676,107.348v20.417h159.299L480.93,357.8H237.759   v-69.86H225.387z M488.362,499.621H387.495H237.759V370.18h250.604V499.621z"
                            />
                            <path
                              class="st000"
                              d="M349.351,460.676v-52.601h-51.045v58.787h51.045V460.676z M336.979,454.482h-26.3v-34.035h26.3V454.482z"
                            />
                            <path
                              class="st000"
                              d="M430.564,460.676v-52.601h-51.045v58.787h51.045V460.676z M418.192,454.482h-26.301v-34.035h26.301V454.482z"
                            />
                            <path
                              class="st000"
                              d="M97.493,305.274h54.913v-6.186v-48.726H97.493V305.274z M109.867,262.734h30.167v30.168h-30.167V262.734z"
                            />
                          </g>
                        </svg>
                        <span class="cat-name">Religious & Ceremonial</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Software')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Layer_1"
                          viewBox="0 0 512 512"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M437.019,74.981C388.668,26.628,324.38,0,256,0C187.62,0,123.333,26.629,74.981,74.981C26.628,123.332,0,187.62,0,256    s26.629,132.667,74.981,181.019C123.332,485.372,187.62,512,256,512s132.667-26.629,181.019-74.981    C485.372,388.668,512,324.38,512,256C512,187.62,485.371,123.333,437.019,74.981z M256,491.102    C126.365,491.102,20.898,385.635,20.898,256S126.365,20.898,256,20.898S491.102,126.365,491.102,256S385.635,491.102,256,491.102z    "
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M339.19,55.612c-26.39-10.967-54.379-16.528-83.188-16.528c-5.771,0-10.449,4.678-10.449,10.449    c0,5.771,4.678,10.449,10.449,10.449c26.043,0,51.334,5.023,75.169,14.928c1.31,0.544,2.669,0.802,4.005,0.802    c4.095,0,7.983-2.424,9.654-6.442C347.044,63.942,344.519,57.827,339.19,55.612z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M443.92,147.583c-18.399-31.824-44.779-58.661-76.292-77.609c-4.943-2.974-11.364-1.375-14.339,3.57    c-2.974,4.945-1.375,11.365,3.57,14.339c59.586,35.83,95.16,98.676,95.16,168.116c0,5.771,4.678,10.449,10.449,10.449    c5.771,0,10.449-4.678,10.449-10.449C472.917,217.887,462.89,180.397,443.92,147.583z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M256,178.678c-42.636,0-77.322,34.686-77.322,77.322s34.686,77.322,77.322,77.322s77.322-34.686,77.322-77.322    C333.322,213.364,298.636,178.678,256,178.678z M256,312.424c-31.112,0-56.424-25.312-56.424-56.425    c0-31.113,25.312-56.424,56.424-56.424c31.112,0,56.425,25.312,56.425,56.424C312.424,287.113,287.112,312.424,256,312.424z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M256,219.429c-20.165,0-36.571,16.406-36.571,36.571c0,20.166,16.406,36.571,36.571,36.571    c20.166,0,36.571-16.406,36.571-36.571C292.571,235.835,276.166,219.429,256,219.429z M256,271.673    c-8.642,0-15.673-7.031-15.673-15.673c0-8.642,7.031-15.673,15.673-15.673c8.642,0,15.673,7.031,15.673,15.673    C271.673,264.642,264.642,271.673,256,271.673z"
                              />
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Software</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Sporting Goods')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          version="1.1"
                          id="Capa_1"
                          viewBox="0 0 512.001 512.001"
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <rect
                                x="247.522"
                                y="120.412"
                                width="15.773"
                                height="15.773"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="247.522"
                                y="144.597"
                                width="15.773"
                                height="15.773"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="118.104"
                                y="209.005"
                                transform="matrix(0.309 -0.9511 0.9511 0.309 -119.3137 269.7703)"
                                width="15.774"
                                height="15.977"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="140.896"
                                y="216.401"
                                transform="matrix(0.309 -0.9511 0.9511 0.309 -110.5984 296.5583)"
                                width="15.774"
                                height="15.977"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="172.38"
                                y="351.981"
                                transform="matrix(0.5878 -0.809 0.809 0.5878 -216.7874 294.2542)"
                                width="15.976"
                                height="15.773"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="186.506"
                                y="332.607"
                                transform="matrix(0.5878 -0.809 0.809 0.5878 -195.2912 297.6976)"
                                width="15.976"
                                height="15.773"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="322.792"
                                y="351.897"
                                transform="matrix(0.809 -0.5878 0.5878 0.809 -148.3834 263.11)"
                                width="15.772"
                                height="15.976"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="308.681"
                                y="332.497"
                                transform="matrix(0.809 -0.5878 0.5878 0.809 -139.6749 251.1101)"
                                width="15.773"
                                height="15.976"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M437.02,74.981C388.667,26.628,324.38,0,255.999,0C187.619,0,123.333,26.628,74.98,74.981    C26.628,123.333,0,187.62,0,256.001c0,68.381,26.628,132.667,74.98,181.019c48.352,48.352,112.64,74.981,181.019,74.981    s132.668-26.629,181.021-74.981c48.353-48.352,74.981-112.64,74.981-181.019C512.001,187.621,485.372,123.333,437.02,74.981z     M495.863,242.829l-12.206,8.108l-58.932-46.559l22.292-65.223l18.53-0.831C483.461,170.112,493.869,205.684,495.863,242.829z     M207.567,20.64c15.768-3.21,31.972-4.867,48.433-4.867c19.048,0,37.75,2.219,55.83,6.502l6.453,23.118l-62.492,41.662    L200.65,45.699L207.567,20.64z M50.818,130.916l15.358,0.645l20.31,72.308l-56.371,39.663l-13.398-8.846    C19.957,197.593,31.633,162.256,50.818,130.916z M86.134,425.867c-4.653-4.654-9.079-9.472-13.299-14.428l7.841-21.08    l75.045,3.026l20.302,65.87l-19.486,15.538C130.662,463.015,106.838,446.571,86.134,425.867z M425.866,425.866    c-22.964,22.964-49.762,40.695-78.945,52.619l-18.1-14.348l26.069-70.436l68.919,1.046l8.97,23.901    C430.526,421.091,428.23,423.503,425.866,425.866z M434.798,379.139l-81.305-1.234l-7.073-9.735l-12.76,9.27l6.911,9.511    l-30.513,82.441l19.452,15.42c-23.45,7.506-48.178,11.415-73.51,11.415c-28.685,0-56.597-5.007-82.754-14.584l21.018-16.759    l-23.951-77.708l7.074-9.735l-12.761-9.27l-6.91,9.51l-87.834-3.543l-8.475,22.788c-29.627-40.728-45.634-89.593-45.634-140.925    c0-1.006,0.024-2.008,0.037-3.013l14.588,9.631l66.505-46.791l11.444,3.718l4.874-15.001l-11.18-3.632l-23.772-84.63    l-17.212-0.722c7.497-10.361,15.859-20.205,25.078-29.424c29.368-29.368,65.006-50.183,103.891-61.222l-7.441,26.954    l64.941,48.705v12.482h15.773v-12.049l73.253-48.835l-6.967-24.959c35.924,11.51,68.84,31.48,96.283,58.922    c11.39,11.39,21.495,23.725,30.242,36.825l-20.541,0.921l-26.299,76.945l-11.444,3.718l4.874,15.001l11.18-3.632l68.977,54.494    l13.303-8.838c-1.19,52.705-19.277,102.578-51.668,143.401L434.798,379.139z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="377.07"
                                y="209.103"
                                transform="matrix(0.9511 -0.309 0.309 0.9511 -48.205 129.5981)"
                                width="15.978"
                                height="15.774"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <rect
                                x="354.282"
                                y="216.511"
                                transform="matrix(0.9511 -0.309 0.309 0.9511 -51.6089 122.9176)"
                                width="15.978"
                                height="15.774"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M350.07,236.622l-5.978-14.596l-21.486,8.8l-59.308-42.241v-19.799h-15.773v19.974l-58.716,42.1l-21.889-8.848    l-5.911,14.624l18.705,7.561l23.538,71.267l-5.622,7.285l12.487,9.636l2.906-3.766h84.999l2.905,3.766l12.487-9.636l-5.629-7.294    l23.382-71.091L350.07,236.622z M292.039,312.846h-73.041l-22.491-68.098l59.031-42.326l59,42.023L292.039,312.846z"
                              />
                            </g>
                          </g>
                        </svg>
                        <span class="cat-name">Sporting Goods</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Toys & Games')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          fill="#000000"
                          height="800px"
                          width="800px"
                          version="1.1"
                          id="Capa_1"
                          viewBox="0 0 213.383 213.383"
                          xml:space="preserve"
                        >
                          <path
                            d="M143.463,213.383c-2.039,0-4.08-0.382-6.035-1.147l-3.415-1.337c-4.114-1.611-7.355-4.728-9.126-8.776  c-0.852-1.947-1.314-3.998-1.385-6.061c-5.446,1.829-11.128,2.754-16.948,2.754s-11.503-0.925-16.949-2.754  c-0.071,2.062-0.533,4.113-1.385,6.061c-1.771,4.049-5.012,7.165-9.126,8.776l-3.414,1.337c-4.115,1.611-8.61,1.522-12.659-0.248  c-4.048-1.771-7.165-5.012-8.776-9.127l-6.497-16.596c-3.292-8.411,0.8-17.922,9.127-21.336c-0.244-0.62-0.476-1.244-0.696-1.871  c-2.438,1.501-6.122,3.132-10.271,2.764c-4.302-0.373-8.095-2.733-11.275-7.017c-7.001-9.43-3.306-26.41,8.237-37.852  c6.641-6.582,17.073-10.871,23.031-12.931C54.35,97.955,47.124,83.66,47.124,67.83c0-7.299,1.503-14.357,4.472-21.021  c-8.122-4.271-13.239-12.631-13.239-21.968C38.357,11.144,49.501,0,63.198,0C73.57,0,82.753,6.431,86.394,15.937  c6.455-2.162,13.224-3.257,20.16-3.257s13.705,1.095,20.159,3.257C130.354,6.431,139.537,0,149.909,0  c13.697,0,24.841,11.144,24.841,24.841c0,9.337-5.117,17.698-13.239,21.968c2.969,6.665,4.472,13.724,4.472,21.021  c0,15.795-7.193,30.061-18.698,40.124c5.922,2.033,16.513,6.344,23.228,12.999c11.544,11.441,15.239,28.421,8.237,37.852  c-3.18,4.283-6.973,6.644-11.275,7.017c-4.288,0.37-8.063-1.367-10.497-2.904c-0.235,0.675-0.483,1.345-0.746,2.012  c8.328,3.413,12.42,12.925,9.127,21.336l-6.497,16.596c-1.611,4.115-4.728,7.356-8.776,9.127  C147.962,212.917,145.714,213.383,143.463,213.383z M128.628,193.76c-0.33,2.138-0.048,4.329,0.84,6.359  c1.235,2.824,3.497,4.999,6.368,6.123l3.415,1.337c2.87,1.124,6.007,1.063,8.832-0.173c2.825-1.235,5-3.497,6.124-6.368  l6.497-16.596c2.32-5.927-0.614-12.636-6.541-14.956l-3.031-1.187c-6.276-1.755-12.832,1.231-15.625,7.118l-5.844,14.928  c-0.211,0.686-0.371,1.409-0.477,2.159C129.12,192.975,128.923,193.407,128.628,193.76z M61.977,168.299l-3.032,1.188  c-5.927,2.32-8.86,9.029-6.541,14.956l6.497,16.596c1.124,2.871,3.298,5.133,6.124,6.368c2.824,1.235,5.96,1.297,8.833,0.173  l3.414-1.337c2.871-1.124,5.132-3.299,6.368-6.123c0.888-2.03,1.169-4.222,0.84-6.359c-0.295-0.353-0.492-0.785-0.558-1.255  c-0.106-0.75-0.266-1.473-0.477-2.158L77.6,175.418C74.807,169.533,68.253,166.549,61.977,168.299z M88.82,190.453  c5.648,2.231,11.606,3.362,17.734,3.362s12.086-1.131,17.734-3.362c0.106-0.332,0.224-0.662,0.352-0.989l0.307-0.783  c0.111-0.345,0.231-0.685,0.361-1.017l5.161-13.182c0.139-0.354,0.287-0.702,0.444-1.043l0.224-0.572l0,0  c1.611-4.115,4.728-7.355,8.776-9.126c3.72-1.628,7.819-1.835,11.652-0.605c2.223-5.637,3.348-11.573,3.348-17.679  c0-12.466-4.669-24.168-13.191-33.179c-2.901,1.983-5.951,3.702-9.124,5.146c5.961,6.493,9.316,15.01,9.316,23.904  c0,19.497-15.862,35.359-35.36,35.359s-35.36-15.862-35.36-35.359c0-8.895,3.355-17.411,9.316-23.904  c-3.173-1.443-6.223-3.162-9.125-5.146c-8.522,9.011-13.191,20.713-13.191,33.179c0,4.33,0.565,8.574,1.687,12.687  c0.035,0.102,0.064,0.205,0.085,0.31c0.443,1.581,0.968,3.144,1.575,4.683c3.835-1.227,7.933-1.022,11.652,0.605  c4.049,1.771,7.166,5.011,8.776,9.126l0.224,0.572c0.157,0.341,0.306,0.688,0.444,1.043l5.161,13.182  c0.13,0.332,0.25,0.671,0.361,1.017l0.307,0.783C88.596,189.791,88.713,190.121,88.82,190.453z M85.526,119.442  c-5.949,5.717-9.332,13.611-9.332,21.886c0,16.74,13.62,30.359,30.36,30.359c16.741,0,30.36-13.619,30.36-30.359  c0-8.274-3.384-16.169-9.332-21.886c-6.596,2.32-13.63,3.521-20.89,3.537c-0.013-0.005-0.024,0-0.035,0c-0.004,0-0.012,0-0.016,0  c-0.013,0-0.028,0-0.041,0c-0.004,0.001-0.007,0-0.012,0c-0.024,0-0.045,0-0.069,0c-0.004,0-0.008,0.001-0.012,0  c-0.012,0-0.029,0-0.041,0c-0.004,0-0.012,0-0.016,0c-0.01,0.001-0.01,0.011-0.035,0C99.156,122.964,92.122,121.763,85.526,119.442z   M158.458,157.865c1.544,1.167,4.928,3.305,8.613,2.973c2.803-0.253,5.382-1.939,7.665-5.014c4.884-6.579,2.939-20.733-7.742-31.32  c-4.661-4.619-11.679-8.063-17.151-10.255c6.543,9.021,10.07,19.826,10.07,31.208C159.913,149.678,159.425,153.826,158.458,157.865z   M63.148,114.411c-5.416,2.2-12.216,5.591-16.759,10.093c-10.681,10.587-12.626,24.742-7.742,31.32  c2.29,3.084,4.878,4.771,7.693,5.016c3.489,0.304,6.719-1.617,8.351-2.804c-0.994-4.093-1.496-8.298-1.496-12.579  C53.195,134.143,56.679,123.4,63.148,114.411z M106.514,117.979c0.026,0,0.054,0,0.08,0l0,0c0.013,0.002,0.027,0,0.039,0  c0.004-0.001,0.006,0,0.01,0c0.014,0,0.025,0,0.041,0c0.015,0.001,0.03,0.001,0.045,0c0.008,0,0.016,0,0.023,0  c29.922-0.099,54.231-22.558,54.231-50.149c0-7.367-1.698-14.468-5.045-21.105c-0.316-0.626-0.354-1.356-0.106-2.012  c0.249-0.656,0.761-1.177,1.413-1.437c7.597-3.026,12.505-10.263,12.505-18.436C169.75,13.9,160.85,5,149.909,5  c-9.017,0-16.909,6.084-19.192,14.794c-0.18,0.688-0.644,1.266-1.276,1.59c-0.632,0.325-1.373,0.365-2.036,0.111  c-6.62-2.531-13.636-3.815-20.852-3.815s-14.232,1.284-20.852,3.815c-0.663,0.254-1.404,0.214-2.035-0.111  c-0.632-0.324-1.096-0.902-1.276-1.59C80.107,11.084,72.214,5,63.198,5c-10.94,0-19.841,8.9-19.841,19.841  c0,8.172,4.909,15.408,12.506,18.436c0.651,0.26,1.164,0.78,1.413,1.437c0.249,0.655,0.21,1.386-0.106,2.012  c-3.348,6.637-5.045,13.737-5.045,21.105c0,27.592,24.309,50.051,54.231,50.149c0.013,0,0.026,0,0.04,0  c0.014-0.001,0.026-0.001,0.039,0c0.012,0,0.022-0.001,0.037,0c0.012,0.002,0.022,0.001,0.034,0  C106.507,117.979,106.511,117.979,106.514,117.979L106.514,117.979z M106.554,114.519c-18.952,0-34.371-12.405-34.371-27.653  s15.419-27.653,34.371-27.653s34.371,12.405,34.371,27.653c0,12.068-9.658,22.355-23.082,26.121c-0.343,0.184-0.72,0.28-1.099,0.292  C113.523,114.084,110.1,114.519,106.554,114.519z M101.563,109.191c3.245,0.429,6.735,0.429,9.981,0l-4.99-4.99L101.563,109.191z   M109.054,99.631l8.302,8.301c10.867-3.326,18.569-11.515,18.569-21.066c0-12.491-13.176-22.653-29.371-22.653  S77.183,74.374,77.183,86.865c0,9.551,7.704,17.74,18.569,21.066l8.302-8.301V88.688c-4.623-0.926-8.064-4.358-8.064-8.44  c0-4.79,4.739-8.687,10.564-8.687s10.564,3.896,10.564,8.687c0,4.082-3.442,7.515-8.064,8.44V99.631z M106.554,76.561  c-3.016,0-5.564,1.688-5.564,3.687s2.548,3.687,5.564,3.687s5.564-1.688,5.564-3.687S109.57,76.561,106.554,76.561z M128.15,58.395  c-4.566,0-8.28-3.715-8.28-8.28s3.714-8.28,8.28-8.28s8.281,3.715,8.281,8.28S132.716,58.395,128.15,58.395z M128.15,46.834  c-1.809,0-3.28,1.472-3.28,3.28s1.472,3.28,3.28,3.28c1.809,0,3.281-1.472,3.281-3.28S129.959,46.834,128.15,46.834z M84.958,58.395  c-4.566,0-8.281-3.715-8.281-8.28s3.715-8.28,8.281-8.28s8.28,3.715,8.28,8.28S89.524,58.395,84.958,58.395z M84.958,46.834  c-1.809,0-3.281,1.472-3.281,3.28s1.472,3.28,3.281,3.28c1.809,0,3.28-1.472,3.28-3.28S86.766,46.834,84.958,46.834z   M153.924,41.175c-0.762,0-1.499-0.35-1.979-0.974c-4.426-5.738-10.438-10.646-17.388-14.192c-0.895-0.457-1.43-1.405-1.356-2.408  c0.639-8.766,8.029-15.633,16.824-15.633c9.304,0,16.873,7.569,16.873,16.873c0,7.525-5.056,14.203-12.296,16.24  C154.378,41.145,154.15,41.175,153.924,41.175z M138.409,22.391c6.372,3.493,11.973,8.06,16.356,13.336  c4.268-1.863,7.132-6.135,7.132-10.886c0-6.547-5.326-11.873-11.873-11.873C144.373,12.968,139.547,16.996,138.409,22.391z   M58.726,40.936c-0.271,0-0.544-0.044-0.811-0.136c-6.816-2.338-11.396-8.752-11.396-15.959c0-9.304,7.569-16.873,16.874-16.873  c8.663,0,15.876,6.489,16.779,15.096c0.109,1.044-0.445,2.046-1.388,2.507c-7.232,3.535-13.486,8.517-18.087,14.404  C60.213,40.593,59.481,40.936,58.726,40.936z M63.392,12.968c-6.547,0-11.874,5.326-11.874,11.873c0,4.496,2.533,8.554,6.451,10.563  c4.542-5.378,10.341-9.99,16.938-13.473C73.607,16.72,68.919,12.968,63.392,12.968z"
                          />
                        </svg>
                        <span class="cat-name">Toys & Games</span>
                      </a>
                    </li>
                    <li class="category-hover">
                      <a @click="ViewCategoryProduct('Vehicles & Parts')">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="800px"
                          height="800px"
                          viewBox="0 0 48 48"
                          id="a"
                        >
                          <defs></defs>
                          <path
                            class="b"
                            d="M8.4,36.1457s-.1939,1.511,0,2.2286c.1347,.4981,.264,1.3371,.78,1.3371h2.8971c.516,0,.6453-.8391,.78-1.3371,.1939-.7172,0-2.2286,0-2.2286"
                          />
                          <rect
                            class="b"
                            x="4.5"
                            y="21.66"
                            width="39"
                            height="14.4857"
                            rx="4.4571"
                            ry="4.4571"
                          />
                          <path
                            class="b"
                            d="M35.1429,36.1457s-.1939,1.511,0,2.2286c.1347,.4981,.264,1.3371,.78,1.3371h2.8971c.516,0,.6453-.8391,.78-1.3371,.1939-.7172,0-2.2286,0-2.2286"
                          />
                          <circle
                            class="b"
                            cx="10.6286"
                            cy="29.46"
                            r="2.2286"
                          />
                          <path
                            class="b"
                            d="M8.9571,21.66l2.5629-10.0286c.438-1.7138,2.3534-3.3429,4.1229-3.3429h16.7143c1.7695,0,3.6849,1.6291,4.1229,3.3429l2.5629,10.0286"
                          />
                          <circle
                            class="b"
                            cx="37.3714"
                            cy="29.46"
                            r="2.2286"
                          />
                        </svg>
                        <span class="cat-name">Vehicles & Parts</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="container mt-5 pt-5">
              <div class="row d-flex justify-content-between">
                <div class="col-xl-2 col-lg-6 col-md-6">
                  <div class="block-footer">
                    <div class="block-footer-title">Quick Links</div>

                    <div class="block-footer-content">
                      <ul>
                        <li>
                          <router-link to="/Contact_us">Contact Us</router-link>
                        </li>
                        <li>
                          <router-link to="/site/terms_and_conditions"
                            >Terms And Conditions</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/site/about_us"
                            >About Us</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/site/privacy_policy"
                            >Privacy Policy</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/site/affiliate_disclaimer"
                            >Affiliate Disclaimer</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/guava-vs-govava"
                            >Guava vs Govava</router-link
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xl-5 col-lg-12 col-md-12">
                  <div class="block-footer">
                    <div class="block-footer-title">
                      Newsletter Subscribe
                    </div>
                    <div class="block-footer-content">
                      <p class="newsletter-description">
                        Enter your email address for our mailing list to keep
                        yourself update
                      </p>
                      <div class="block-subscribe-footer">
                        <div class="title-middle-footer">
                          Sign Up For Newsletter
                        </div>
                        <div class="newsletter-content">
                          <div class="input-box">
                            <input
                              type="email"
                              class="form-control"
                              :class="{ 'is-invalid': errors.email }"
                              id="newsletter-footer"
                              v-model="email"
                              placeholder="E Mail*"
                              autocomplete="email"
                              @input="onEmailFieldInput"
                              @blur="onEmailFieldBlur"
                            />
                            <span class="text-danger" v-if="errors.email">{{
                              this.errors.email[0]
                            }}</span>
                            <span
                              v-else-if="emailDomainStatus === 'checking'"
                              class="text-muted d-block mt-1 email-field-hint"
                            >
                              Checking email domain...
                            </span>
                          </div>
                          <div class="action-button">
                            <button
                              class="action subscribe primary"
                              @click="subscribemail()"
                              title="Subscribe"
                              type="button"
                            >
                              <span>Subscribe</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-12 col-md-12">
                  <div class="block-footer">
                    <div class="block-footer-title">
                      <router-link to="faq">FAQ</router-link>
                    </div>
                    <div class="block-footer-content content-apps">
                      <app-store-badges />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
        <div class="row">
          <cookie-law theme="blood-orange">
            <div slot-scope="props" style="width: 100%;">
              <p>
                We use cookies to ensure our website works effectively, to
                improve your experience on our website and to show you
                personalized content and advertising. To find out more about the
                cookies this website uses, please see our policy.
              </p>
              <div class="row">
                <div class="col-md-11">
                  <p>
                    The term 'Etsy' is a trademark of Etsy, Inc. This
                    application uses the Etsy API but is not endorsed or
                    certified by Etsy, Inc.
                  </p>
                </div>
                <div class="col-md-1">
                  <button class="skew pull-right" @click="props.accept">
                    <span>I accept</span>
                  </button>
                </div>
              </div>
            </div>
          </cookie-law>
        </div>
        <div class="footer-bottom">
          <div class="container">
            <div class="row">
              <div class="col-lg-4"></div>
              <div class="col-lg-8">
                <div class="copyright-footer">
                  <address>Govava © 2026. All rights reserved.</address>
                  <p class="footer-seo-note">
                    Govava is an AI gift finder — not the tropical fruit guava.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-modal
          id="loader-modal"
          :no-close-on-backdrop="true"
          class="modal-dialog modal-dialog-centered modal-lg"
          scrollable
          ref="my-modal"
          hide-footer
          hide-header
          size="lg"
        >
          <section>
            <div>
              <div class="row">
                <img
                  src="@/assets/site/images/loader.gif"
                  class="img-fluid loader-width"
                  alt
                />
              </div>
            </div>
          </section>
        </b-modal>
      </div>
    </footer>
  </div>
</template>
<script>
import BackToTop from "vue-backtotop";
import CookieLaw from "vue-cookie-law";
import { Balloon } from "vue-balloon";
import AppStoreBadges from "@/components/AppStoreBadges.vue";
import emailFieldMixin from "@/mixins/emailFieldMixin";

export default {
  name: "FooterBar",
  components: { CookieLaw, Balloon, BackToTop, AppStoreBadges },
  mixins: [emailFieldMixin],
  data() {
    return {
      loader: false,
      errors: [],
      pages: [],
      browsemenus: [],
      email: null,
      components: {
        BackToTop,
      },
      modal: false,
      search_word: null,
      cookie_message: "",
      overlayVideo: null,
      description: null,
      route_name: "",
    };
  },
  created() {
    this.getBrowsmenus();
    this.getOverlayVideo();
    this.checkurl();
  },
  methods: {
    getBrowsmenus() {
      this.loader = true;
      var token = localStorage.getItem("userData");
      if (token != null) {
        var userdata_array = JSON.parse(token);
        var api_token = userdata_array.token;
      }
      var fetch_url =
        process.env.VUE_APP_URL + "customer/browsemenu/getBrowseMenu";
      fetch(fetch_url, {
        method: "get",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: "Bearer " + api_token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          this.browsemenus = data.browsemenu;
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    async subscribemail() {
      this.errors = [];

      const emailValidation = await this.validateEmailFieldComplete();
      if (!emailValidation.valid) {
        return;
      }

      this.email = emailValidation.email;
      let apiUrl = process.env.VUE_APP_URL + "customer/saveSubscribemail";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          // Authorization: "Bearer " + $('meta[name="api_token"]').attr("content")
        },
        body: JSON.stringify({
          email: this.email,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            this.resetForm();
            this.$swal("Success", data.message, "success");
            this.resetForm();
            // this.showModal();
          } else if (data.status === false) {
            this.$swal("Error", data.message, "error");
          } else {
            this.errors = data.errors;
          }
          this.loader = false;
        })
        .catch(function(err) {
          console.log("Conatct Data", "Error : " + err.message, "error");
        });
    },
    resetForm() {
      this.email = null;
      this.emailDomainStatus = "idle";
    },
    ViewCategoryProduct(category) {
      // this.modal = true;
      this.$bvModal.show("loader-modal");
      var fetch_url =
        process.env.VUE_APP_URL + "customer/search/keyword_search";
      fetch(fetch_url, {
        method: "post",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          // Authorization: "Bearer " + api_token,
        },
        body: JSON.stringify({
          keyword: this.search_word,
          category: category,
          page: 1,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          //  this.modal = false;
          this.$bvModal.hide("loader-modal");
          window.scrollTo(0, 0);
          this.modal = false;
          var products = data.response;
          // const id = "view_" + i;

          const id = Math.random()
            .toString(36)
            .slice(2);
          this.$store.state.isGiftCard = false;
          this.$store.state.keyword = this.search_word;
          this.$store.state.category = category;
          this.$store.state.products = data.response.item;
          this.$store.state.totalPages = data.response.pagination.max_page;
          this.$store.state.result_cursor =
            data.response.pagination.result_cursor || null;
          this.$store.state.page = 1;
          this.$router.replace({
            name: "SearchView",
            params: {
              id,
            },
          });
          //
          // this.search_word = null;
          // this.selected_category = '';
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    getOverlayVideo() {
      var videoStatus = localStorage.getItem("videoStatus");
      if (videoStatus == null) {
        var fetch_url = process.env.VUE_APP_URL + "customer/videos/getVideo";
        // var fetch_url = "https://core-api.govava.com/customer/videos/getVideo";
        fetch(fetch_url, {
          method: "post",
          headers: {
            "content-type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            // Authorization: "Bearer " + api_token,
          },
          body: JSON.stringify({
            keyword: this.search_word,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.video.video) {
              let splitUrl = data.video.video?.split("/");
              this.overlayVideo = splitUrl[splitUrl.length - 1];
            } else this.overlayVideo = null;
            this.description = data.video.description;
            // localStorage.setItem("videoStatus", JSON.stringify(true));
          })
          .catch(function(err) {
            console.log("Fetch Error :-S", err);
          });
      }
    },
    closeVideo() {
      localStorage.setItem("videoStatus", JSON.stringify(false));
    },
    checkurl() {
      var segment_str = window.location.pathname;
      var segment_array = segment_str.split("/");
      this.route_name = segment_array[1];
    },
  },
  watch: {
    $route(to, from) {
      let split_route = to.path.split("/");
      this.route_name = split_route[1];
    },
  },
};
</script>
<style>
.b {
  fill: none;
  stroke: #fe3c00;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.cls-1 {
  fill: none;
  stroke: #fe3c00;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.st0 {
  display: none;
}
.st1 {
  display: inline;
  opacity: 0.93;
}
.st2 {
  display: inline;
  fill: none;
  stroke: #fe3c00;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st3 {
  display: inline;
}
.st4 {
  fill: none;
  stroke: #fe3c00;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st5 {
  display: inline;
  fill: none;
  stroke: #fe3c00;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st6 {
  fill: #fe3c00;
}
.st7 {
  fill: #fe3c00;
}
.st8 {
  fill: #fe3c00;
}
.st9 {
  fill: #fe3c00;
}
.st10 {
  fill: #fe3c00;
}
.st11 {
  fill: #fe3c00;
}
.st12 {
  fill: #fe3c00;
}
.st13 {
  fill: none;
}
.st14 {
  fill: none;
  stroke: #fe3c00;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st15 {
  display: inline;
  fill: #fe3c00;
}
.st16 {
  fill: #fe3c00;
}
.st17 {
  display: inline;
  fill: #fe3c00;
}

.category-hover {
  cursor: pointer;
}

.category-hover a {
  height: 60px;
  padding-left: 8px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
}

.category-hover a svg {
  display: block;
  height: 32px !important;
  width: 32px !important;
  fill: #fe3c00;
  color: #fe3c00;
}

.category-hover a svg rect {
  stroke: #fe3c00;
}

.category-hover a svg path {
  stroke: #fe3c00;
}

.category-hover a svg line {
  stroke: #fe3c00;
}

.vb.vb-bottom-left.vb.vb-maximized {
  width: 600px !important;
  height: 500px;
}

.vb.vb-bottom-left.vb.vb-maximized .col-md-5 {
  max-width: 100% !important;
  flex: none !important;
}

.vb-wrapper .vb-header,
.vb-wrapper:not(.vb-multiple) .vb-header {
  background: #fff !important;
  color: #777;
  padding: 0px !important;
  height: 2px !important;
  border-bottom: none !important;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.vb-wrapper .vb-content,
.vb-wrapper:not(.vb-multiple) .vb-content {
  position: relative;
  width: auto !important;
  height: auto !important;
  min-width: 350px !important;
  max-width: 550px !important;
  max-height: 177px;
  overflow: hidden !important;
  background: #fff !important;
}
.vb-wrapper .vb-content-slot,
.vb-wrapper:not(.vb-multiple) .vb-content-slot {
  -webkit-transform-origin: 0% 0%;
  transform-origin: 0% 0%;
  -webkit-transform: scale(1);
  transform: scale(1);
  width: 550px !important;
  height: 100%;
}
.vb-wrapper .vb-header .vb-buttons,
.vb-wrapper:not(.vb-multiple) .vb-header .vb-buttons {
  float: right;
  padding-right: 5px !important;
}
.vb-wrapper .vb-header .vb-buttons,
.vb-wrapper:not(.vb-multiple) .vb-header .vb-buttons {
  float: right;
  padding-right: 5px !important;
  position: absolute !important;
  right: 2% !important;
  top: 1% !important;
  bottom: 80% !important;
  z-index: 9999 !important;
}
.baloon-video {
  height: 100% !important;
  /* border-radius: 15px !important; */
  /* width: 100% !important; */
}
.vb.vb-bottom-left.vb.vb-maximized iframe {
  width: 530px !important;
  height: 350px !important;
}
.vb-wrapper .vb-minimized-overlay,
.vb-wrapper:not(.vb-multiple) .vb-minimized-overlay .vb-content {
  max-height: 177px !important;
}
.vb {
  border-radius: 15px !important;
  padding-left: 7px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  overflow: hidden !important;
  background: #fff !important;
}
.vb-wrapper .vb-minimized-overlay,
.vb-wrapper:not(.vb-multiple) .vb-minimized-overlay {
  -webkit-transition: opacity 0.25s;
  transition: opacity 0.25s;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  background: none !important;
  cursor: pointer;
}

@media (max-width: 767px) {
  .vb-wrapper .vb-content,
  .vb-wrapper:not(.vb-multiple) .vb-content {
    position: relative;
    width: 280px !important;
    height: auto !important;
    max-width: 275px !important;
    /* max-height: 160px !important; */
    overflow: hidden !important;
    background: #fff !important;
  }
  .vb.vb-bottom-left {
    /* width: 290px !important; */
  }
  .vb-wrapper .vb-content-slot,
  .vb-wrapper:not(.vb-multiple) .vb-content-slot {
    -webkit-transform-origin: 0% 0%;
    transform-origin: 0% 0%;
    -webkit-transform: scale(1);
    transform: scale(1);
    width: 280px !important;
    height: 100%;
  }
}
.video-description {
  line-height: 1.5;
}

.footer-seo-note {
  margin: 0.5rem 0 0;
  font-size: 13px;
  color: #888;
  font-style: italic;
}
</style>
